// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:07:42.198Z
// Property: Chesterfield Flats (ID: 6767906449166314)
// Collections: 30 amenities, 13 floorplans (live), 23 photos, 70 POIs, 4 reviews, 4 virtual tours, 6 office hours, 7 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166314",
  "property_external_id": "30943",
  "property_zillow_url": "https://www.zillow.com/apartments/north-chesterfield-va/chesterfield-flats/5hJjF6/",
  "property_apartments_url": "https://www.apartments.com/chesterfield-flats-richmond-va/g9sc27z/",
  "property_google_business_url": "https://www.google.com/maps/place/Chesterfield+Flats/data=!4m2!3m1!1s0x0:0x6e9644d3ab551f69?sa=X&ved=2ahUKEwi9-eD5lriSAxUbnokEHUxxM8sQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "53465975365",
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "chesterfield-flats",
  "property_name": "Chesterfield Flats",
  "property_website_url": "https://www.chesterfieldflats.com/",
  "property_domain": "https://www.chesterfieldflats.com/",
  "property_address": "6300 Pewter Avenue",
  "property_full_address": "6300 Pewter Ave, Richmond, VA 23224",
  "property_address_1": "6300 Pewter Ave",
  "property_address_2": null,
  "property_address_city": "Richmond",
  "property_address_state": "VA",
  "property_address_zip_full": "23224-5618",
  "property_address_zip": "23224",
  "property_address_country": "US",
  "property_address_county": "Chesterfield County",
  "property_neighborhood_address": "Chesterfield County",
  "property_address_latitude": "37.4647217",
  "property_address_longitude": "-77.5106122",
  "property_email": "ChesterfieldFlats@aionmanagement.com",
  "property_phone": "(804) 276-6911",
  "property_call_tracking_phone": "866-392-0810",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Chesterfield Flats in vibrant Richmond, VA, where modern living meets comfort. Choose from spacious one, two, or three-bedroom floor plans, and enjoy top-notch amenities like a refreshing swimming pool, a pet-friendly dog park, and a fully-equipped fitness center. Secure your dream home today—schedule a tour or check our availability!",
  "property_long_description": "Welcome to Chesterfield Flats, your ideal apartment community nestled in the heart of Richmond, VA. Discover a variety of spacious floor plans tailored to fit your lifestyle, featuring one, two, and three-bedroom options designed for comfort and convenience. At Chesterfield Flats, you'll enjoy a host of exceptional amenities, making every day feel like a getaway. \n\nDive into our vibrant resident activities, perfect for building connections with your neighbors. Our community is pet-friendly, so your furry friends are welcome to join you! With on-site parking, multi-sports court, and a state-of-the-art fitness center, staying active has never been easier. Unwind and relax at our sparkling swimming pool or soak up the sun on the sundeck, followed by a delightful barbecue at our grilling stations. \n\nStay connected with high-speed internet and utilize our online resident portal for added convenience. Our dedicated on-site management and 24-hour emergency maintenance ensure that your needs are met at all times. Whether you're enjoying a game at our playground, relaxing in the courtyard, or engaging in outdoor picnics, Chesterfield Flats has something for everyone. \n\nWith flexible rent payments and short-term lease options available, we make it easy to find your new home. Each apartment features essential comforts like air conditioning, electric ranges, and stackable washers and dryers, ensuring you feel right at home. \n\nDon't miss out on the opportunity to live in this thriving community. Find your new home today—browse our availability or schedule a tour to visit Chesterfield Flats!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-94c2-710f-9dc3-5fffeb28efc0.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
    "public_id": "019fce38-94c2-710f-9dc3-5fffeb28efc0",
    "storage_key": "property/6767906449166314/019fce38-94c2-710f-9dc3-5fffeb28efc0.webp",
    "width": 1920,
    "height": 1282
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "278",
  "property_year_built": "1975",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.5251798561151",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Maximum 2 pets per apartment, each up to 100 lb. Breed restrictions apply (e.g., German Shepherds, Akitas, Rottweilers, Pit Bulls, etc.). All pets must be housebroken.",
  "property_pet_policy_description": "Cats and dogs are welcome. Maximum 2 pets per apartment, each up to 100 lb. Breed restrictions apply (e.g., German Shepherds, Akitas, Rottweilers, Pit Bulls, etc.). All pets must be housebroken. Pet fee: $350 non‑refundable. Monthly pet rent: $50 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://chesterfieldflats.loftliving.com/login",
  "property_apply_now_url": "https://www.chesterfieldflats.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0267-5331-7790-bc40-b346ef2102a0.webp",
  "property_primary_logo_media": {
    "alt_text": "Chesterfield Flats logo with an orange oak leaf and text.",
    "public_id": "019d0267-5331-7790-bc40-b346ef2102a0",
    "storage_key": "property/6767906449166314/019d0267-5331-7790-bc40-b346ef2102a0.webp",
    "width": 640,
    "height": 86
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0267-5331-7790-bc40-b346ef2102a0.webp",
  "property_secondary_logo_media": {
    "alt_text": "Chesterfield Flats logo with an orange oak leaf and text.",
    "public_id": "019d0267-5331-7790-bc40-b346ef2102a0",
    "storage_key": "property/6767906449166314/019d0267-5331-7790-bc40-b346ef2102a0.webp",
    "width": 640,
    "height": 86
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0267-7063-7078-8fd4-e6a35631edaf.webp",
  "property_icon_media": {
    "alt_text": "Oak leaf logo",
    "public_id": "019d0267-7063-7078-8fd4-e6a35631edaf",
    "storage_key": "property/6767906449166314/019d0267-7063-7078-8fd4-e6a35631edaf.webp",
    "width": 150,
    "height": 150
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0267-7063-7078-8fd4-e6a35631edaf.webp",
  "property_fav_icon_media": {
    "alt_text": "Oak leaf logo",
    "public_id": "019d0267-7063-7078-8fd4-e6a35631edaf",
    "storage_key": "property/6767906449166314/019d0267-7063-7078-8fd4-e6a35631edaf.webp",
    "width": 150,
    "height": 150
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0267-5c36-7505-aa01-1d949761d6d3.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Chesterfield Flats logo with an oak leaf and text.",
    "public_id": "019d0267-5c36-7505-aa01-1d949761d6d3",
    "storage_key": "property/6767906449166314/019d0267-5c36-7505-aa01-1d949761d6d3.webp",
    "width": 640,
    "height": 86
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0267-667d-736a-99cb-9b235ae4a40b.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Chesterfield Flats logo with an oak leaf emblem.",
    "public_id": "019d0267-667d-736a-99cb-9b235ae4a40b",
    "storage_key": "property/6767906449166314/019d0267-667d-736a-99cb-9b235ae4a40b.webp",
    "width": 640,
    "height": 86
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1.5",
  "property_sqft_range": "600 - 1032",
  "property_sqft_min": "600",
  "property_sqft_max": "1032",
  "property_price_range": "2667",
  "property_price_min": null,
  "property_price_max": "2667",
  "property_available_units": 18,
  "property_facebook_url": "https://facebook.com/livechesterfield",
  "property_instagram_url": "https://www.instagram.com/chesterfieldflats/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJxwTr054NsYkRaR9Vq9NElm4",
  "property_youtube_url": "https://www.youtube.com/shorts/D8aoZkZbV6E",
  "property_yelp_url": "https://www.yelp.com/biz/rollingwood-apartments-richmond",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Chesterfield Flats",
  "property_home_romance_title": "Embrace Comfort and Community in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Chesterfield Flats in Richmond, VA, where comfort meets convenience. Choose from our spacious one, two, or three-bedroom apartments, designed for modern living. Enjoy engaging resident activities, a sparkling pool, pet-friendly parks, and high-speed internet—all with hassle-free online payments. Your ideal home awaits in our vibrant community!",
  "property_home_floorplans_blurb": "At Chesterfield Flats in Richmond, VA, your ideal living space awaits. Choose from stylish one, two, or three-bedroom layouts designed for comfort and convenience. Each floor plan complements your lifestyle, offering the perfect blend of modern amenities and local charm. Browse our available apartment homes today and find your perfect fit!",
  "property_home_gallery_blurb": "At Chesterfield Flats in Richmond, VA, comfort meets convenience. Choose from thoughtfully designed one, two, or three-bedroom floor plans, complete with pet-friendly amenities. Enjoy resident activities, a refreshing swimming pool, and a vibrant dog park. Picture your new life here, where every detail is crafted for your lifestyle!",
  "property_home_neighborhood_blurb": "At Chesterfield Flats, immerse yourself in a vibrant Richmond, VA community. Close to renowned schools, recreational parks, and cultural gems like the Science Museum and the Virginia Museum of Fine Arts, your new home offers unrivaled access to both adventure and tranquility. Uncover the excitement of living here!",
  "property_home_reviews_blurb": "At Chesterfield Flats in Richmond, VA, residents rave about the outstanding customer service and swift maintenance, with many saying it feels like home. With amenities like a pool, gym, and in-unit washers, you’re set for comfort. Join a community where “the office and maintenance staff have always been so good.” ",
  "property_neighborhood_blurb": "At Chesterfield Flats, vibrant living meets endless exploration in Richmond, VA. Nestled amidst enriching attractions like the Virginia Museum of Fine Arts, the serenity of James River Park, and the historical charm of Henricus Historical Park, our community offers a blend of nature, culture, and convenience around every corner. See what's nearby!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Chesterfield Flats in Richmond, VA, residents enjoy a vibrant lifestyle with amenities designed for comfort and convenience. From a refreshing swimming pool to a pet-friendly dog park and engaging resident activities, your perfect home awaits. Embrace modern living in spacious one to three-bedroom apartments and townhomes.",
  "property_applynow_blurb": "At Chesterfield Flats in Richmond, VA, our thoughtfully designed one, two, and three-bedroom apartments offer a vibrant community alive with activities and amenities. From a refreshing swimming pool and fitness center to playful spaces for your furry friends, your ideal lifestyle awaits. Secure your lease online and welcome home today!",
  "property_contactus_blurb": "At Chesterfield Flats in Richmond, VA, our thoughtfully designed floor plans feature spacious one, two, and three-bedroom apartments that cater to your lifestyle. Whether seeking a cozy retreat or a family-friendly haven, we have the perfect space for you. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Chesterfield Flats in Richmond, VA, we offer thoughtfully designed one, two, and three-bedroom floor plans to suit your lifestyle. Curious about our community? Visit our FAQs page for insights into amenities, leasing, and what makes Chesterfield Flats your ideal home. Your questions are just a click away!",
  "property_floorplans_blurb": "At Chesterfield Flats in Richmond, VA, diverse floor plans await to suit your lifestyle, from cozy one-bedroom retreats to spacious three-bedroom homes. Each design combines comfort and style, ensuring a welcoming atmosphere. Browse our available apartment homes and uncover the perfect layout for your next chapter.",
  "property_gallery_blurb": "At Chesterfield Flats in Richmond, VA, picture a vibrant lifestyle where comfort meets community. With spacious one, two, and three-bedroom floor plans, enjoy amenities like a sparkling swimming pool, a dog park, and engaging resident activities. Your perfect home awaits—start envisioning your new life today!",
  "property_interactivemap_blurb": "At Chesterfield Flats in Richmond, VA, a vibrant lifestyle awaits! Choose from one, two, or three-bedroom layouts and enjoy amenities like a fitness center, sparkling pool, and dog park. Our interactive community map makes finding your perfect home simple. Your cozy retreat is just a click away!",
  "property_pets_blurb": "At Chesterfield Flats in Richmond, VA, your furry friends are more than welcome! Enjoy spacious living with your pets in our vibrant community. With a two-pet limit and plenty of green space nearby, your dogs and cats will feel right at home. Join us for a pet-friendly lifestyle today!",
  "property_referafriend_blurb": "At Chesterfield Flats in Richmond, VA, our charming apartment options cater to every lifestyle, with one, two, and three-bedroom floor plans designed for comfort and style. Great friends make great neighbors—refer a friend to our vibrant community today and enjoy the perks of connecting with those you love!",
  "property_residentaccess_blurb": "At Chesterfield Flats in Richmond, VA, your ideal living space awaits—choose from our thoughtfully designed one, two, or three-bedroom floor plans. Log in to your resident portal for seamless access to rent payments, maintenance requests, and exclusive community updates. Embrace a lifestyle where convenience meets comfort!",
  "property_reviews_blurb": "At Chesterfield Flats in Richmond, VA, residents rave about the welcoming community and responsive staff. One resident shares, \"The office and maintenance staff have always been so good to me.\" With top-notch amenities like a refreshing pool and updated gym, it’s a fantastic place to call home. Join us today!",
  "property_created_at": "1757004991229",
  "property_scheduletour_blurb": "At Chesterfield Flats in vibrant Richmond, VA, our thoughtfully designed one, two, and three-bedroom floor plans cater to your lifestyle. Experience comfort and community in a place where every detail counts. Ready for a glimpse into life here? Schedule a tour and hear directly from our happy residents!",
  "property_thankyou_blurb": "Thank you for reaching out to Chesterfield Flats in vibrant Richmond, VA! With thoughtfully designed one, two, and three-bedroom floor plans, your perfect home awaits. Our team will connect with you soon to help you find your ideal living space in our welcoming community. Stay tuned!",
  "property_virtualtours_blurb": "Step into your dream living space at Chesterfield Flats in Richmond, VA. Whether you need a cozy one-bedroom, a spacious two-bedroom, or a luxurious three-bedroom, our diverse floor plans cater to your lifestyle. Take a virtual tour today and envision your future home in our vibrant community!",
  "property_copyright": "2025 All Rights Reserved. Chesterfield Flats",
  "property_seo_title_home": "Chesterfield Flats |  Apartments in Richmond, VA",
  "property_seo_description_home": "Unwind at Chesterfield Flats in Richmond, VA. Enjoy spacious floor plans, fantastic amenities, and a vibrant community. Your new home awaits—find it today!",
  "property_seo_title_floorplans": "Floor Plans | Richmond, VA Apartments for Rent",
  "property_seo_description_floorplans": "Chesterfield Flats in Richmond, VA offers versatile floor plans—one, two, or three bedrooms. Find the ideal space for your lifestyle today!",
  "property_seo_title_amenities": "Amenities | Richmond, VA Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Chesterfield Flats in Richmond, VA! Enjoy pet-friendly living with a pool, fitness center, and more. Your perfect home awaits—come see!",
  "property_seo_title_gallery": "Gallery | Apartments in Richmond, VA",
  "property_seo_description_gallery": "Discover vibrant living at Chesterfield Flats! Enjoy refreshing pools, pet-friendly spaces, and a community designed for your best life!",
  "property_seo_title_virtualtours": "Virtual Tours | Chesterfield Flats Apartments",
  "property_seo_description_virtualtours": "Step into Chesterfield Flats in Richmond, VA! Tour our stylish one, two, and three-bedroom apartments virtually and envision your new home today.",
  "property_seo_title_interactivemap": "Interactive Map | Chesterfield Flats Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Chesterfield Flats, Richmond, VA! Explore our one-to-three-bedroom apartments with great amenities on our interactive map.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Richmond, VA",
  "property_seo_description_neighborhood": "Experience the charm of Chesterfield Flats in Richmond, VA. Uncover local gems and vibrant hotspots surrounding our welcoming community. Your adventure awaits!",
  "property_seo_title_contact": "Contact Us | Chesterfield Flats",
  "property_seo_description_contact": "Reach out to Chesterfield Flats in Richmond, VA, for your ideal one, two, or three-bedroom apartment. We're here to answer your questions—let's connect!",
  "property_seo_title_faqs": "FAQs | Apartments in Richmond, VA",
  "property_seo_description_faqs": "Find quick answers to your questions at Chesterfield Flats! Discover community perks, floor plans, and more in Richmond, VA. Your ideal home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Richmond, VA",
  "property_seo_description_reviews": "Experience life at Chesterfield Flats in Richmond, VA! Check out our resident reviews and see why our community is the perfect place to call home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Richmond, VA",
  "property_seo_description_applynow": "Welcome to Chesterfield Flats in Richmond, VA! With flexible living options, pet-friendly amenities, and a vibrant community—your perfect home awaits!",
  "property_seo_title_residentaccess": "Resident Access | Chesterfield Flats",
  "property_seo_description_residentaccess": "Welcome to Chesterfield Flats in Richmond, VA! Log in to access your resident portal seamlessly—pay rent, schedule maintenance, and manage your home with ease!",
  "property_seo_title_referafriend": "Refer A Friend | Chesterfield Flats",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Chesterfield Flats in Richmond, VA, and enjoy a vibrant community together. Connect and thrive!",
  "property_seo_title_scheduletour": "Schedule a Tour | Chesterfield Flats",
  "property_seo_description_scheduletour": "Experience modern living at Chesterfield Flats in Richmond, VA. Schedule your tour today and uncover your next home in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Chesterfield Flats",
  "property_seo_description_privacy": "At Chesterfield Flats in Richmond, VA, we prioritize your privacy. Discover how we protect your info while you enjoy our vibrant community.",
  "property_seo_title_accessibility": "Website Accessibility | Chesterfield Flats",
  "property_seo_description_accessibility": "At Chesterfield Flats in Richmond, VA, we prioritize accessibility. Join us in fostering an inclusive community—where everyone feels at home and connected!",
  "property_seo_title_sitemap": "Sitemap | Chesterfield Flats",
  "property_seo_description_sitemap": "Navigate your way to a perfect home at Chesterfield Flats in Richmond, VA. Check out our sitemap for an easy journey to your future living space!",
  "property_seo_title_thankyou": "Thank You | Chesterfield Flats",
  "property_seo_description_thankyou": "Thank you for reaching out to Chesterfield Flats in Richmond, VA! Our team will connect with you soon to make your apartment search seamless and enjoyable.",
  "property_seo_title_pets": "Pet Policy | Apartments in Richmond, VA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293667734",
  "amenities": [
    {
      "id": "custom_9ff4efd0-590a-47b6-a415-61dc1ec74bc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ec5b8a21-93f7-4091-bac2-a46ca203783b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_daa4e865-0c6a-4cfa-bec0-7e0c75194a10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f64c39a2-aa4a-44f4-864a-67b7a2475f5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_233d5ce2-0e8a-4d02-a2a1-15dc677dda7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0e4b3027-0f42-4eb3-bd29-455117e3aa43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Onsite Management",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3cd0e087-6c66-413b-95d3-e57136cf4c4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6703234e-5632-4c95-a400-28ad39763c3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Short Term Leases",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8efd3751-5e21-4727-9ebe-5c6d5c634dca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bf5687b4-47f0-4e69-aaa6-0de9a6ec3063",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Bi-Level Townhomes",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_605564c9-eca7-4dcd-aeee-7d321105ba28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2187fcda-b8ca-49f3-8e42-3a44cdb434da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fan*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a9913216-a66f-4197-a12f-7d8c9d4d31fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6b17017d-0313-4064-b218-56550bd8cded",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Full-Size Washer & Dryer Hook-Ups*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0d7a92ed-ca0b-4d03-b65f-edc64ec6a9ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Fully Equipped Kitchens",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d31de4fa-4d5f-4d33-8e86-aeaf92db907c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "High-Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d2e2b208-6038-457e-b48e-576816bd20ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e80c6d5c-1305-477f-8e6f-9e38b79008f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_048d02ef-1bf6-4b5a-bc40-771adaca7312",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Kitchens with Breakfast Bar Available*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fba3e2ec-92af-4ed9-bd5e-c7af87d00fc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_70e5a0e2-fa2a-4089-a943-ebf0d784339f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Excellent Chesterfield County Schools",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0572f88f-c575-4491-93ef-9bc73c3ce877",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Park-Like Setting with Mature Landscaping",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7f42d395-80cd-4d28-a1c7-cd2078e83939",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "15 Minutes to Virginia Commonwealth University",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7782e833-3669-4985-9339-9ed39eb04dca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "6 Miles to Downtown Richmond",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2d6b2e06-57a1-45ae-8f4b-07aeb338cee9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c938ab91-4265-426f-806e-f7393e59071c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling Stations and Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_80148e91-80a4-466a-87cd-6e41b4d8c794",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Multi-Purpose Activity Court: (Race Track, Foursquare, Hop Scotch & More)",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2528b25b-6902-4d2f-8439-29e1d63c1daa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_431213d3-82a4-4751-91e6-e955fc85fcf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool with Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e45aff4d-8b55-4c06-a8d7-0c7ce6b4ea1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "external_id": "false",
      "title": "Carpeting & Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_79415e89-b83f-47bf-a339-b308cff075d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-ab68-77b5-aa15-f0e321d1489a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances, white cabinets, and granite countertops.",
        "public_id": "019fce38-ab68-77b5-aa15-f0e321d1489a",
        "storage_key": "property/6767906449166314/019fce38-ab68-77b5-aa15-f0e321d1489a.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring sleek black appliances, ample white cabinetry, and elegant granite countertops, perfect for preparing meals.",
      "link": "",
      "alt_text": "A small kitchen with white cabinets, black appliances, and gray countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/6f4bcf36/dms3rep/multi/DSC_3935_0007_DSC_3985_v7gjt7.jpg"
    },
    {
      "id": "custom_9c8bbb37-32b5-4de1-956b-5768781938a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a05d44-8c4b-7387-8b7f-0ec6210b80a4.webp",
      "image_media": {
        "alt_text": "Bright and airy living and dining area with a white sofa, armchair, and dining set.",
        "public_id": "01a05d44-8c4b-7387-8b7f-0ec6210b80a4",
        "storage_key": "property/6767906449166314/01a05d44-8c4b-7387-8b7f-0ec6210b80a4.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed living and dining area, featuring a comfortable white sofa, a stylish armchair, and a charming dining set perfect for hosting guests.",
      "link": "",
      "alt_text": "Bright and airy living and dining area with a white sofa, armchair, and dining set.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2498c1ec-b9c2-4c29-a13a-4dd10b19e1a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a05d44-8c50-73bd-9d63-203f3140081e.webp",
      "image_media": {
        "alt_text": "Dining area with a round table, four chairs, and a black refrigerator.",
        "public_id": "01a05d44-8c50-73bd-9d63-203f3140081e",
        "storage_key": "property/6767906449166314/01a05d44-8c50-73bd-9d63-203f3140081e.webp",
        "width": 1535,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Stylish dining area featuring a round table with seating for four, complemented by elegant chairs and modern wall art. A black refrigerator adds a sleek touch to the space.",
      "link": "",
      "alt_text": "Dining area with a round table, four chairs, and a black refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_722f1cbb-21d9-422a-856b-fa69f3d069d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a05d44-8ce1-730f-b2ec-85df6a7c713b.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, yellow and white bedding, and a wooden nightstand with a lamp.",
        "public_id": "01a05d44-8ce1-730f-b2ec-85df6a7c713b",
        "storage_key": "property/6767906449166314/01a05d44-8ce1-730f-b2ec-85df6a7c713b.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Apartment",
      "description": "A beautifully appointed bedroom featuring a comfortable queen-size bed, modern decor, and a large window offering natural light.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, yellow and white bedding, and a wooden nightstand with a lamp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_26ab07b1-9c72-4cf4-add2-ec8f0b8e3a10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-acbe-75ca-8eff-253ae5e93555.webp",
      "image_media": {
        "alt_text": "Living room with a white sectional sofa, coffee table, TV, and a large plant.",
        "public_id": "019fce38-acbe-75ca-8eff-253ae5e93555",
        "storage_key": "property/6767906449166314/019fce38-acbe-75ca-8eff-253ae5e93555.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable white sectional sofa, a rustic coffee table, and a modern entertainment center with a flat-screen TV. Large sliding glass doors offer access to an outdoor space.",
      "link": "",
      "alt_text": "Living room with white sofa, wooden coffee table, and large potted plant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/6f4bcf36/dms3rep/multi/DSC_3935_0004_DSC_4005_domz9s.jpg"
    },
    {
      "id": "custom_85bc00fd-f4d1-4dbe-89e3-67aef7cf3ea6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-b7ee-7323-9149-3e61e4e9a406.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four chairs next to a black refrigerator and white cabinets.",
        "public_id": "019fce38-b7ee-7323-9149-3e61e4e9a406",
        "storage_key": "property/6767906449166314/019fce38-b7ee-7323-9149-3e61e4e9a406.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "A bright and modern dining area featuring a round wooden table with upholstered chairs, adjacent to a sleek black refrigerator and crisp white cabinetry.",
      "link": "",
      "alt_text": "Kitchen and dining area with black refrigerator, wooden table, and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/6f4bcf36/dms3rep/multi/DSC_3935_0006_DSC_3991_dhlbyl.jpg"
    },
    {
      "id": "custom_d641595b-f8e2-4155-b6ce-b90447641cf2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-b988-77c8-b7b6-a11a7000ba48.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, ceiling fan, and closet. A doorway leads to a bathroom.",
        "public_id": "019fce38-b988-77c8-b7b6-a11a7000ba48",
        "storage_key": "property/6767906449166314/019fce38-b988-77c8-b7b6-a11a7000ba48.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, ceiling fan, and ample closet space. Adjacent bathroom offers modern fixtures.",
      "link": "",
      "alt_text": "Bedroom with bed, closet, and doorway to bathroom. Gray walls, white trim, ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/6f4bcf36/dms3rep/multi/DSC_3935_0011_DSC_3940_jwzpqy.jpg"
    },
    {
      "id": "custom_d4bd32c8-4b01-4115-81d5-830a5a62bb29",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-c1ba-7592-a60b-a46cbbfc0859.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019fce38-c1ba-7592-a60b-a46cbbfc0859",
        "storage_key": "property/6767906449166314/019fce38-c1ba-7592-a60b-a46cbbfc0859.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this modern apartment bathroom, featuring a sleek white vanity, a pristine toilet, and a clean bathtub with a shower curtain.",
      "link": "",
      "alt_text": "A small, white bathroom with a sink, toilet, and shower/tub combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/6f4bcf36/dms3rep/multi/DSC_3935_0008_DSC_3965_ale5fb.jpg"
    },
    {
      "id": "custom_cb816321-d354-4d79-9f10-72b048952c9c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-c3cc-703c-982b-0488f0a9d6eb.webp",
      "image_media": {
        "alt_text": "Bathroom with sink, shower, and stacked washer/dryer unit.",
        "public_id": "019fce38-c3cc-703c-982b-0488f0a9d6eb",
        "storage_key": "property/6767906449166314/019fce38-c3cc-703c-982b-0488f0a9d6eb.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Compact and functional bathroom featuring a sink, shower with a patterned curtain, and a convenient stacked washer and dryer unit.",
      "link": "",
      "alt_text": "Bathroom with white sink, shower, and stacked washer/dryer; gray walls and window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/6f4bcf36/dms3rep/multi/DSC_3935_0000_DSC_4021_vkpn1p.jpg"
    },
    {
      "id": "custom_eea1ccb1-d95f-4736-9372-2d0c7d00524b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-c46e-723c-95a9-d22924a3414b.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas surrounding the deck.",
        "public_id": "019fce38-c46e-723c-95a9-d22924a3414b",
        "storage_key": "property/6767906449166314/019fce38-c46e-723c-95a9-d22924a3414b.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax poolside in our beautiful outdoor swimming pool, surrounded by comfortable lounge chairs and shaded umbrellas.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs, orange umbrellas, and a table with chairs. Blue sky and trees in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/6f4bcf36/dms3rep/multi/DSC_6031_0011_DSC_6018_gicey5.jpg"
    },
    {
      "id": "custom_1e089ab5-8ea4-4f5c-8bfc-a1612440a734",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-c4ac-71cd-a418-4d42ae72da21.webp",
      "image_media": {
        "alt_text": "Bright blue swimming pool with lounge chairs and umbrellas, framed by a wooden pergola.",
        "public_id": "019fce38-c4ac-71cd-a418-4d42ae72da21",
        "storage_key": "property/6767906449166314/019fce38-c4ac-71cd-a418-4d42ae72da21.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling pool, surrounded by comfortable lounge chairs and shaded areas, perfect for a relaxing day outdoors.",
      "link": "",
      "alt_text": "Pool area with wooden pergola, lounge chairs, and building in the background on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/6f4bcf36/dms3rep/multi/DSC_6031_0013_Layer_0_pbrkjl.jpg"
    },
    {
      "id": "custom_d8f12205-a2ea-43fc-a30f-167953f48ca5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-cc11-776f-b52d-387a284d7c1f.webp",
      "image_media": {
        "alt_text": "Treadmills, elliptical machines, and fitness balls in a gym with orange walls and mirrors.",
        "public_id": "019fce38-cc11-776f-b52d-387a284d7c1f",
        "storage_key": "property/6767906449166314/019fce38-cc11-776f-b52d-387a284d7c1f.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Stay active and energized in our fully-equipped fitness center, featuring cardio machines and free weights.",
      "link": "",
      "alt_text": "Gym interior with treadmills, elliptical, exercise balls, and exercise chart. Orange and white walls, black floor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/6f4bcf36/dms3rep/multi/DSC_6031_0009_DSC_6098_tqwo7v.jpg"
    },
    {
      "id": "custom_61fd01f8-e267-464f-8f7d-81f78d173cc2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-ce82-70bb-a3c5-c0b80311828b.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, medicine balls, exercise balls, and a core exercises mat.",
        "public_id": "019fce38-ce82-70bb-a3c5-c0b80311828b",
        "storage_key": "property/6767906449166314/019fce38-ce82-70bb-a3c5-c0b80311828b.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring a variety of weight machines, medicine balls, and stability balls for a complete workout.",
      "link": "",
      "alt_text": "Gym interior with exercise equipment: medicine balls, stability balls, and weight machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/6f4bcf36/dms3rep/multi/DSC_6031_0008_DSC_6108_cqjwrr.jpg"
    },
    {
      "id": "custom_3a2b3a80-db4e-4b32-ba20-edccc4e6f418",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-cf93-73dc-b317-e2ce8b23ccbd.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, weight machines, and free weights.",
        "public_id": "019fce38-cf93-73dc-b317-e2ce8b23ccbd",
        "storage_key": "property/6767906449166314/019fce38-cf93-73dc-b317-e2ce8b23ccbd.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Our fully equipped fitness center offers cardio machines, weight training equipment, and free weights to help you achieve your fitness goals.",
      "link": "",
      "alt_text": "Gym with weights, treadmill, exercise equipment, and mirrors; black flooring and white walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/6f4bcf36/dms3rep/multi/DSC_6031_0007_DSC_6116_pr5t4a.jpg"
    },
    {
      "id": "custom_43432552-b297-46b0-91c7-3f75ba4ceb2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-d282-761a-b963-dfdcfc50fbff.webp",
      "image_media": {
        "alt_text": "Dog park with agility tunnel and play equipment.",
        "public_id": "019fce38-d282-761a-b963-dfdcfc50fbff",
        "storage_key": "property/6767906449166314/019fce38-d282-761a-b963-dfdcfc50fbff.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, featuring an agility tunnel and playful dog-themed equipment for your furry friends to enjoy.",
      "link": "",
      "alt_text": "Dog park with tunnel and agility equipment; wood chip ground, fenced, apartment building background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/6f4bcf36/dms3rep/multi/DSC_4236_0004_DSC_4248_t9q9xr.jpg"
    },
    {
      "id": "custom_c5df7f1a-f1a6-490b-92e4-8e3bc9a44876",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-d797-7021-a05b-d27ca82aded1.webp",
      "image_media": {
        "alt_text": "Multipurpose sports court with hopscotch and running track markings.",
        "public_id": "019fce38-d797-7021-a05b-d27ca82aded1",
        "storage_key": "property/6767906449166314/019fce38-d797-7021-a05b-d27ca82aded1.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Enjoy recreation on the multipurpose court, featuring hopscotch and a running track, surrounded by lush greenery and apartment buildings.",
      "link": "",
      "alt_text": "Blue running track with white lines, surrounded by trees and a white building under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/6f4bcf36/dms3rep/multi/DSC_6031_0005_DSC_6044_q5ss6s.jpg"
    },
    {
      "id": "custom_056937da-c095-48be-b25f-c924e8d61fd7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-d9b2-721b-bc37-d805f011b1dc.webp",
      "image_media": {
        "alt_text": "Welcome to the Dog Park sign and banner",
        "public_id": "019fce38-d9b2-721b-bc37-d805f011b1dc",
        "storage_key": "property/6767906449166314/019fce38-d9b2-721b-bc37-d805f011b1dc.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "A dedicated dog park area with a welcoming sign and an AION Management banner.",
      "link": "",
      "alt_text": "Orange sign welcoming to a dog park with a paw print. Orange flag on right reads \"Dog Park.\"",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/6f4bcf36/dms3rep/multi/DSC_6031_0001_DSC_6082_if2df4.jpg"
    },
    {
      "id": "custom_d31c97cf-8d3b-47ef-ab48-fe8e9672e8c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-dd81-7208-bab4-a45628e59452.webp",
      "image_media": {
        "alt_text": "Colorful playground with slides and climbing walls.",
        "public_id": "019fce38-dd81-7208-bab4-a45628e59452",
        "storage_key": "property/6767906449166314/019fce38-dd81-7208-bab4-a45628e59452.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring slides and climbing structures for endless entertainment.",
      "link": "",
      "alt_text": "Playground with yellow slides, blue climbing wall, and dark mulch, surrounded by trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/6f4bcf36/dms3rep/multi/DSC_6031_0000_DSC_6094_kklnqb.jpg"
    },
    {
      "id": "custom_fcc646a2-1c2b-42af-b8e8-7e212d6671e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-defc-71d8-a4c3-98ac31479a26.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fce38-defc-71d8-a4c3-98ac31479a26",
        "storage_key": "property/6767906449166314/019fce38-defc-71d8-a4c3-98ac31479a26.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge seating.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs, umbrellas, and apartments in the background under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/6f4bcf36/dms3rep/multi/DSC_6031_0010_DSC_6020_gp39vm.jpg"
    },
    {
      "id": "custom_4c8f5ac2-ba85-4f53-ae3a-1a8e7ff91319",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-e390-73d9-84c9-226a91399387.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and windows.",
        "public_id": "019fce38-e390-73d9-84c9-226a91399387",
        "storage_key": "property/6767906449166314/019fce38-e390-73d9-84c9-226a91399387.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings showcasing balconies, windows, and surrounding green spaces.",
      "link": "",
      "alt_text": "Two-story tan apartment building with balconies, set on a green lawn with trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/6f4bcf36/dms3rep/multi/DSC_6067.jpg"
    },
    {
      "id": "custom_7bcba7cc-6d86-448a-ac3a-2ea4f3fb95e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-e5f7-775a-97b1-6105da632c99.webp",
      "image_media": {
        "alt_text": "Exterior view of a garden-style apartment building with light yellow siding and balconies.",
        "public_id": "019fce38-e5f7-775a-97b1-6105da632c99",
        "storage_key": "property/6767906449166314/019fce38-e5f7-775a-97b1-6105da632c99.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Beautifully maintained exterior of the apartment building, showcasing the charming architecture and lush landscaping.",
      "link": "",
      "alt_text": "Two-story tan apartment building with balconies, set on a green lawn with trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/6f4bcf36/dms3rep/multi/DSC_6031_0003_DSC_6056_hljhl3.jpg"
    },
    {
      "id": "custom_f400b2ea-e76d-4446-acd4-a1765e99c511",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-ea82-76f9-b7a3-b632d3b72d0a.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool and hot tub area with lounge chairs and umbrellas, surrounded by apartment buildings and parking lots.",
        "public_id": "019fce38-ea82-76f9-b7a3-b632d3b72d0a",
        "storage_key": "property/6767906449166314/019fce38-ea82-76f9-b7a3-b632d3b72d0a.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling swimming pool or unwind in the soothing hot tub. This community offers the perfect amenities for your leisure.",
      "link": "",
      "alt_text": "Aerial view of an apartment complex with a pool, playground, and parking. Green trees and blue pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/6f4bcf36/dms3rep/multi/1111_tmdy8p.jpg"
    },
    {
      "id": "custom_0ab1e887-5e73-4e4d-81fd-b4b0cc339387",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-eab2-76de-b26f-e68617d7e62a.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by trees and a distant cityscape.",
        "public_id": "019fce38-eab2-76de-b26f-e68617d7e62a",
        "storage_key": "property/6767906449166314/019fce38-eab2-76de-b26f-e68617d7e62a.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Aerial perspective showcasing a sprawling apartment complex nestled amidst lush greenery, with a glimpse of a distant urban skyline.",
      "link": "",
      "alt_text": "Aerial view of a suburban neighborhood with houses, roads, and a vast green forest under a partly cloudy sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/6f4bcf36/dms3rep/multi/DJI_20230831105542_0157_D_0001_Background_ucmvgc.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_1fac9a87-d463-4773-b75d-bc81b9e371c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "1590 Koger Center Blvd, North Chesterfield, VA 23235, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-fdba-7095-b56d-3fc8e7f00162.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce38-fdba-7095-b56d-3fc8e7f00162",
        "storage_key": "property/6767906449166314/019fce38-fdba-7095-b56d-3fc8e7f00162.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/va/chesterfield-plaza?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=9544648806214875227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "37.5122466",
      "poi_longitude": "-77.6107827",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 804-594-3930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cd82-73a8-875c-b76c17b7101f",
        "storage_key": "property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBxagBJ9tsYkRWzhLAIVndYQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8f1cbdb5-c9e5-4c7f-98e5-832755dae789",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "1570 Koger Center Blvd, Richmond, VA 23235, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-fd45-75aa-b2c7-2f89f62b9764.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce38-fd45-75aa-b2c7-2f89f62b9764",
        "storage_key": "property/6767906449166314/019fce38-fd45-75aa-b2c7-2f89f62b9764.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/virginia/chesterfield?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=6125381732179240968&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "37.5118764",
      "poi_longitude": "-77.6118898",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 804-897-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cd82-73a8-875c-b76c17b7101f",
        "storage_key": "property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq5oN555tsYkRCOg1VDu6AVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c832bc24-bdfd-4f48-a44f-2e4786d9b00f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "CAVA",
      "poi_type": "Restaurants",
      "poi_address": "1403 Huguenot Rd, Midlothian, VA 23113, USA",
      "poi_short_description": "Mediterranean restaurant for thoughtful food with customizable greens & grains bowls, pitas & salad.",
      "poi_long_description": "Mediterranean restaurant for thoughtful food with customizable greens & grains bowls, pitas & salad.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-fd54-75ff-9a4d-04bfbc762708.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce38-fd54-75ff-9a4d-04bfbc762708",
        "storage_key": "property/6767906449166314/019fce38-fd54-75ff-9a4d-04bfbc762708.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cava.com/locations/midloathian-va",
      "poi_directions_map_url": "https://maps.google.com/?cid=10203869697873350795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cava",
      "poi_latitude": "37.5119202",
      "poi_longitude": "-77.6137112",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 804-251-8040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cd82-73a8-875c-b76c17b7101f",
        "storage_key": "property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhx8TKZltsYkRixAdhG1tm40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_72e8e8e6-c901-4cc1-9250-79ef65a42b92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "First Watch",
      "poi_type": "Restaurants",
      "poi_address": "1403 Huguenot Rd Ste A, Midlothian, VA 23113, USA",
      "poi_short_description": "Cafe chain for health-minded breakfast, brunch & lunch options such as omelets, salads & soups.",
      "poi_long_description": "Cafe chain for health-minded breakfast, brunch & lunch options such as omelets, salads & soups.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce38-fd58-7629-ad7e-6a390d87c2c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce38-fd58-7629-ad7e-6a390d87c2c0",
        "storage_key": "property/6767906449166314/019fce38-fd58-7629-ad7e-6a390d87c2c0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.firstwatch.com/locations/midlothian/?utm_source=gbp-listing&utm_medium=organic&utm_campaign=gbp-listing&utm_content=midlothian",
      "poi_directions_map_url": "https://maps.google.com/?cid=5194388236078719577&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-watch",
      "poi_latitude": "37.5122545",
      "poi_longitude": "-77.6137044",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 804-302-8516",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cd82-73a8-875c-b76c17b7101f",
        "storage_key": "property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfV_KZltsYkRWaLwZJQsFkg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_56ff73ac-b7f5-4868-908c-b90de4dfe9be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Mellow Mushroom Midlothian",
      "poi_type": "Restaurants",
      "poi_address": "1409 Huguenot Rd, Midlothian, VA 23113, USA",
      "poi_short_description": "Funky, art-filled chain pizzeria featuring craft beer, calzones & creative stone-baked pizzas.",
      "poi_long_description": "Funky, art-filled chain pizzeria featuring craft beer, calzones & creative stone-baked pizzas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-044e-763d-b42c-13b2241da803.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-044e-763d-b42c-13b2241da803",
        "storage_key": "property/6767906449166314/019fce39-044e-763d-b42c-13b2241da803.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mellowmushroom.com/locations/va/midlothian/1409-huguenot-road?utm_source=gmb&utm_medium=organic&utm_campaign=Midlothian-VA&utm_content=215",
      "poi_directions_map_url": "https://maps.google.com/?cid=9823505163360564109&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mellow-mushroom-midlothian",
      "poi_latitude": "37.5128282",
      "poi_longitude": "-77.6142442",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 804-594-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cd82-73a8-875c-b76c17b7101f",
        "storage_key": "property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhx8TKZltsYkRjXNSH-YZVIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_44a6d7d4-d2d8-4d8c-882a-d7bd95c6dd99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Tazza Kitchen Alverser Plaza",
      "poi_type": "Restaurants",
      "poi_address": "1244 Alverser Plaza, Midlothian, VA 23113, USA",
      "poi_short_description": "Outlet offering wood-fired pies, regional wines & local brews in a warm setting with a bar.",
      "poi_long_description": "Outlet offering wood-fired pies, regional wines & local brews in a warm setting with a bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-0391-7681-acc7-6b9b802b0eb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-0391-7681-acc7-6b9b802b0eb3",
        "storage_key": "property/6767906449166314/019fce39-0391-7681-acc7-6b9b802b0eb3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.tazzakitchen.com/locations/alverserplaza",
      "poi_directions_map_url": "https://maps.google.com/?cid=10643173673126703351&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tazza-kitchen-alverser-plaza",
      "poi_latitude": "37.5100688",
      "poi_longitude": "-77.61577419999999",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 804-415-6224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cd82-73a8-875c-b76c17b7101f",
        "storage_key": "property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUGCfZltsYkR97CB1RAmtJM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_72dbea07-6af3-4e23-bc73-0c9b9b662158",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "11649 Midlothian Tpke, Midlothian, VA 23113, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-04c5-7178-844d-0ae0aa46941f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-04c5-7178-844d-0ae0aa46941f",
        "storage_key": "property/6767906449166314/019fce39-04c5-7178-844d-0ae0aa46941f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/va/midlothian/11649-midlothian-turnpike?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=600783&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=2387870201881843537&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "37.5044973",
      "poi_longitude": "-77.61352839999999",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 804-897-7222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cd83-70a2-a57b-f2a7a408878c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cd83-70a2-a57b-f2a7a408878c",
        "storage_key": "property/6767906449166314/019d0265-cd83-70a2-a57b-f2a7a408878c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJMyCMVJttsYkRUVfoEExrIyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_23bb8e7e-462b-4ed5-9fcd-2d2a18e678f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "11440 Midlothian Tpke, North Chesterfield, VA 23235, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-040f-741e-a701-9a82cf0e918b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-040f-741e-a701-9a82cf0e918b",
        "storage_key": "property/6767906449166314/019fce39-040f-741e-a701-9a82cf0e918b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.chipotle.com/va/north-chesterfield/11440-midlothian-tpke?utm_source=google&utm_medium=yext&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=11049597393191909336&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "37.506017",
      "poi_longitude": "-77.607333",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 804-379-2791",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cd82-73a8-875c-b76c17b7101f",
        "storage_key": "property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe_Dm2ndtsYkR2DdJLEkOWJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1b7eaaf4-3012-4801-88cb-a39e6332764a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Kickback Jack's",
      "poi_type": "Restaurants",
      "poi_address": "10330 Midlothian Tpke, Richmond, VA 23235, USA",
      "poi_short_description": "Local sports bar chain serving steak, seafood & pub grub in a lively, contemporary setting.",
      "poi_long_description": "Local sports bar chain serving steak, seafood & pub grub in a lively, contemporary setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-0a34-75ed-8955-ef72b7f73c42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-0a34-75ed-8955-ef72b7f73c42",
        "storage_key": "property/6767906449166314/019fce39-0a34-75ed-8955-ef72b7f73c42.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://www.kbjacks.com/richmond-va-midlothian-turnpike",
      "poi_directions_map_url": "https://maps.google.com/?cid=6474819399539421140&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kickback-jacks",
      "poi_latitude": "37.5074271",
      "poi_longitude": "-77.58796819999999",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-272-6234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cd82-73a8-875c-b76c17b7101f",
        "storage_key": "property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMeRx1GttsYkR1O9aVvAt21k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3c09cc7b-5dda-41f5-b923-018aa464d681",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Latitude Seafood Co. Westchester Commons",
      "poi_type": "Restaurants",
      "poi_address": "15532 Westchester Commons Way, Midlothian, VA 23113, USA",
      "poi_short_description": "Airy, contemporary seafood joint matches a large menu of fish-focused eats with craft cocktails.",
      "poi_long_description": "Airy, contemporary seafood joint matches a large menu of fish-focused eats with craft cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-0b17-766e-ad23-92cf109885f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-0b17-766e-ad23-92cf109885f4",
        "storage_key": "property/6767906449166314/019fce39-0b17-766e-ad23-92cf109885f4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.latitudeseafoodco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13997923647595765378&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "latitude-seafood-co-westchester-commons",
      "poi_latitude": "37.5139338",
      "poi_longitude": "-77.6930785",
      "poi_miles_from_property": "13.2 mi",
      "poi_walking_minutes": "4 hours 55 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 804-379-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cd82-73a8-875c-b76c17b7101f",
        "storage_key": "property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJowuftjFusYkRgl78r2SdQsI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_839767c9-47d0-4504-a513-5d244cbde0b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Papa Lou Pizza",
      "poi_type": "Restaurants",
      "poi_address": "5310 Hull Street Rd #8, Richmond, VA 23224, USA",
      "poi_short_description": "Pizza shop offering familiar pies, along with wings, lasagna, cheesesteaks, and garlic knots.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-0b4f-7122-8cb3-2548024a2669.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-0b4f-7122-8cb3-2548024a2669",
        "storage_key": "property/6767906449166314/019fce39-0b4f-7122-8cb3-2548024a2669.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.papaloupizzarva.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10536546845905092191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "papa-lou-pizza",
      "poi_latitude": "37.490817",
      "poi_longitude": "-77.4920783",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 804-233-8559",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cd82-73a8-875c-b76c17b7101f",
        "storage_key": "property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2aiOQw0SsYkRX35vBYhVOZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_35bd87b0-2703-4057-bbb3-38d3b4437852",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Amanecer Latino Market 1",
      "poi_type": "Restaurants",
      "poi_address": "5301 Old Midlothian Turnpike, Richmond, VA 23224, USA",
      "poi_short_description": "Salvadoran comfort food such as pupusas is served at this informal restaurant with fresh tortillas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-0b7c-7285-80ef-668125b6db2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-0b7c-7285-80ef-668125b6db2b",
        "storage_key": "property/6767906449166314/019fce39-0b7c-7285-80ef-668125b6db2b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2025595475853351981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amanecer-latino-market-1",
      "poi_latitude": "37.5065661",
      "poi_longitude": "-77.4950908",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 804-232-1775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cd82-73a8-875c-b76c17b7101f",
        "storage_key": "property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwXAIwkASsYkRLZzgbFpcHBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_676f54cd-7a32-416c-9f21-05bb9dbea8cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Ruth's Chris Steak House",
      "poi_type": "Restaurants",
      "poi_address": "11500 W Huguenot Rd, Midlothian, VA 23113, USA",
      "poi_short_description": "Outpost of upmarket steakhouse chain known for sizzling, butter-topped beef in an elegant setting",
      "poi_long_description": "Outpost of upmarket steakhouse chain known for sizzling, butter-topped beef in an elegant setting",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-10c7-73b8-a82e-c4a4b4fd5646.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-10c7-73b8-a82e-c4a4b4fd5646",
        "storage_key": "property/6767906449166314/019fce39-10c7-73b8-a82e-c4a4b4fd5646.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ruthschrisva.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1397134617638087666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ruths-chris-steak-house",
      "poi_latitude": "37.5248052",
      "poi_longitude": "-77.6108994",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 804-378-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cd82-73a8-875c-b76c17b7101f",
        "storage_key": "property/6767906449166314/019d0265-cd82-73a8-875c-b76c17b7101f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7Ti-LaZtsYkR8iu4S4ieYxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_acb3b2d6-b915-4d02-88d8-d967b96d8c9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "J.A. Chalkley Elementary School",
      "poi_type": "Education",
      "poi_address": "3301 Turner Rd, Chesterfield, VA 23832, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-11ba-753c-9fda-7dc58ae3af94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-11ba-753c-9fda-7dc58ae3af94",
        "storage_key": "property/6767906449166314/019fce39-11ba-753c-9fda-7dc58ae3af94.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://chalkleyes.oneccps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5090374791137639321&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ja-chalkley-elementary-school",
      "poi_latitude": "37.4649737",
      "poi_longitude": "-77.5188256",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 804-674-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cdd9-72ed-8aa4-8df02c84aafc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cdd9-72ed-8aa4-8df02c84aafc",
        "storage_key": "property/6767906449166314/019d0265-cdd9-72ed-8aa4-8df02c84aafc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqYGHBnUNsYkRmbtcD-ekpEY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b18a0f98-31eb-42e7-959e-6a490ac3f924",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Providence Middle School",
      "poi_type": "Education",
      "poi_address": "900 Starlight Ln, Richmond, VA 23235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-1267-70ae-b431-ecd9e7bb29b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-1267-70ae-b431-ecd9e7bb29b4",
        "storage_key": "property/6767906449166314/019fce39-1267-70ae-b431-ecd9e7bb29b4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.oneccps.org/pvms/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4514848741419750689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-middle-school",
      "poi_latitude": "37.4883187",
      "poi_longitude": "-77.54289299999999",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 804-674-1355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cdd9-72ed-8aa4-8df02c84aafc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cdd9-72ed-8aa4-8df02c84aafc",
        "storage_key": "property/6767906449166314/019d0265-cdd9-72ed-8aa4-8df02c84aafc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkRcY1KASsYkRIZXxdgL3pz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_629ed10d-f62a-4f90-ae45-939198abc2dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Meadowbrook High School",
      "poi_type": "Education",
      "poi_address": "4901 Cogbill Rd, North Chesterfield, VA 23234, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://mychesterfieldschools.com/mbkhs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=859364361644379709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meadowbrook-high-school",
      "poi_latitude": "37.4354762",
      "poi_longitude": "-77.48327479999999",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 804-743-3675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cdd9-72ed-8aa4-8df02c84aafc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cdd9-72ed-8aa4-8df02c84aafc",
        "storage_key": "property/6767906449166314/019d0265-cdd9-72ed-8aa4-8df02c84aafc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl-BPeTIMsYkRPY5xdFUT7Qs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_240bbc98-79bd-41f5-9c49-afeb26359191",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Swansboro Elementary School",
      "poi_type": "Education",
      "poi_address": "3160 Midlothian Tpke, Richmond, VA 23224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-1231-7228-b1f8-47e8c811ab91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-1231-7228-b1f8-47e8c811ab91",
        "storage_key": "property/6767906449166314/019fce39-1231-7228-b1f8-47e8c811ab91.webp",
        "width": 724,
        "height": 1280
      },
      "poi_business_url": "https://ses.rvaschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12799457357576361039&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "swansboro-elementary-school",
      "poi_latitude": "37.5108606",
      "poi_longitude": "-77.46656709999999",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 804-780-5030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cdd9-72ed-8aa4-8df02c84aafc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cdd9-72ed-8aa4-8df02c84aafc",
        "storage_key": "property/6767906449166314/019d0265-cdd9-72ed-8aa4-8df02c84aafc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-xjJOoYRsYkRT1QZ_KbOoLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5a08c5f0-3695-44c4-a635-d315b9402936",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Oak Grove-Bellemeade Elementary School",
      "poi_type": "Education",
      "poi_address": "2409 Webber Ave, Richmond, VA 23224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-1791-72ae-a6f4-f69ba5623eed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-1791-72ae-a6f4-f69ba5623eed",
        "storage_key": "property/6767906449166314/019fce39-1791-72ae-a6f4-f69ba5623eed.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ogbes.rvaschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14223962116963668585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-grove-bellemeade-elementary-school",
      "poi_latitude": "37.496711",
      "poi_longitude": "-77.4421393",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-780-5008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cdd9-72ed-8aa4-8df02c84aafc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cdd9-72ed-8aa4-8df02c84aafc",
        "storage_key": "property/6767906449166314/019d0265-cdd9-72ed-8aa4-8df02c84aafc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3S4vkLwRsYkRaZI7AC-qZcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ec98ad11-d592-49ea-84df-ac8cdbd36daf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Cardinal Elementary School",
      "poi_type": "Education",
      "poi_address": "1745 Catalina Dr, Richmond, VA 23224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://cardinales.rvaschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7772480885061549548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cardinal-elementary-school",
      "poi_latitude": "37.4908465",
      "poi_longitude": "-77.4754846",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 804-780-5082",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cdd9-72ed-8aa4-8df02c84aafc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cdd9-72ed-8aa4-8df02c84aafc",
        "storage_key": "property/6767906449166314/019d0265-cdd9-72ed-8aa4-8df02c84aafc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJC3SHRBsSsYkR7H2bQS9m3Ws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_08479488-5ab9-45de-b152-53fd8b4915ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Virginia Commonwealth University",
      "poi_type": "Education",
      "poi_address": "Richmond, VA 23284, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-1819-76aa-830d-6bd48140c0ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-1819-76aa-830d-6bd48140c0ed",
        "storage_key": "property/6767906449166314/019fce39-1819-76aa-830d-6bd48140c0ed.webp",
        "width": 900,
        "height": 599
      },
      "poi_business_url": "http://vcu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1682113867784917192&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-commonwealth-university",
      "poi_latitude": "37.5469205",
      "poi_longitude": "-77.45416449999999",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 804-828-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cdd9-72ed-8aa4-8df02c84aafc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cdd9-72ed-8aa4-8df02c84aafc",
        "storage_key": "property/6767906449166314/019d0265-cdd9-72ed-8aa4-8df02c84aafc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_3Le1yMRsYkRyBAUiaYRWBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8fc0611b-9ab8-46ac-8b31-41ecdd31dce3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "410 Westhampton Way",
      "poi_type": "Education",
      "poi_address": "410 Westhampton Way, Richmond, VA 23173, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-1948-70ff-8623-a397e577c3ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-1948-70ff-8623-a397e577c3ea",
        "storage_key": "property/6767906449166314/019fce39-1948-70ff-8623-a397e577c3ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11539126774048606380&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "410-westhampton-way",
      "poi_latitude": "37.5758243",
      "poi_longitude": "-77.5397192",
      "poi_miles_from_property": "11.1 mi",
      "poi_walking_minutes": "4 hours 6 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cf6d-77aa-9439-53d9b8fc5b9c",
        "storage_key": "property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtXlSJ6IUsYkRrMhdAao2I6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7f0de2f4-2bb8-484f-b59f-aed534c0335f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Reynolds Community College (Downtown Campus)",
      "poi_type": "Education",
      "poi_address": "700 E Jackson St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-18c9-70ee-b345-e388b7aa52eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-18c9-70ee-b345-e388b7aa52eb",
        "storage_key": "property/6767906449166314/019fce39-18c9-70ee-b345-e388b7aa52eb.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1047220594730068864&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reynolds-community-college-downtown-campus",
      "poi_latitude": "37.5457194",
      "poi_longitude": "-77.43130889999999",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 804-371-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cdd9-72ed-8aa4-8df02c84aafc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cdd9-72ed-8aa4-8df02c84aafc",
        "storage_key": "property/6767906449166314/019d0265-cdd9-72ed-8aa4-8df02c84aafc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsb8CSyQRsYkRgOtbHpV5iA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6af35822-5544-495b-894c-ac7ae7591555",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Sprout School RVA",
      "poi_type": "Education",
      "poi_address": "2626 W Broad St, Richmond, VA 23220, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://sproutschoolrva.org/locations/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2989911175111607478&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sprout-school-rva",
      "poi_latitude": "37.5625285",
      "poi_longitude": "-77.467396",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 804-643-6761",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cdd9-72ed-8aa4-8df02c84aafc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cdd9-72ed-8aa4-8df02c84aafc",
        "storage_key": "property/6767906449166314/019d0265-cdd9-72ed-8aa4-8df02c84aafc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdcTuJFURsYkRtoR_Xl9Mfik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2f1228d7-5ec4-4caf-85a0-38549c298f6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Children's Museum Chesterfield",
      "poi_type": "Entertainment",
      "poi_address": "6629 Lake Harbour Dr, Midlothian, VA 23112, USA",
      "poi_short_description": "Clean museum featuring interactive exhibits like an art area, a grocery store, a toy shop and a tire installation.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-1eee-7474-8dac-3e92a2031f91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-1eee-7474-8dac-3e92a2031f91",
        "storage_key": "property/6767906449166314/019fce39-1eee-7474-8dac-3e92a2031f91.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cmorva.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17384345003090798417&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-museum-chesterfield",
      "poi_latitude": "37.4048067",
      "poi_longitude": "-77.6736348",
      "poi_miles_from_property": "13.4 mi",
      "poi_walking_minutes": "4 hours 56 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 804-474-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d274-761a-83fd-b743fb666083.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d274-761a-83fd-b743fb666083",
        "storage_key": "property/6767906449166314/019d0265-d274-761a-83fd-b743fb666083.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJT194Krh2sYkRUWcQkqyZQfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_895cbcbb-b1fc-4a54-a03a-e0a3734fa966",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Henricus Historical Park",
      "poi_type": "Entertainment",
      "poi_address": "251 Henricus Park Rd, Chester, VA 23836, USA",
      "poi_short_description": "Living-history museum depicting an English settlement with Colonial buildings & costumed actors.",
      "poi_long_description": "Living-history museum depicting an English settlement with Colonial buildings & costumed actors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-1f70-7258-862e-58e126a57ea1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-1f70-7258-862e-58e126a57ea1",
        "storage_key": "property/6767906449166314/019fce39-1f70-7258-862e-58e126a57ea1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://henricus.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10744774198675317598&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "henricus-historical-park",
      "poi_latitude": "37.3739728",
      "poi_longitude": "-77.36235680000001",
      "poi_miles_from_property": "16.0 mi",
      "poi_walking_minutes": "5 hours 50 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 804-748-1611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d274-761a-83fd-b743fb666083.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d274-761a-83fd-b743fb666083",
        "storage_key": "property/6767906449166314/019d0265-d274-761a-83fd-b743fb666083.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJyz7bAAIGsYkRXiPTlzQbHZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_324b8c9c-fa91-45ea-b510-1366ab50028e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "AMC DINE-IN Midlothian 10",
      "poi_type": "Entertainment",
      "poi_address": "1100 Alverser Dr, Midlothian, VA 23113, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-1fbd-7069-8056-1b639aac1c8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-1fbd-7069-8056-1b639aac1c8a",
        "storage_key": "property/6767906449166314/019fce39-1fbd-7069-8056-1b639aac1c8a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/richmond-va/amc-dine-in-midlothian-10?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=8167833506866826610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-dine-in-midlothian-10",
      "poi_latitude": "37.506793",
      "poi_longitude": "-77.61974699999999",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 804-897-1999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d27e-715e-9611-4e2855798699.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d27e-715e-9611-4e2855798699",
        "storage_key": "property/6767906449166314/019d0265-d27e-715e-9611-4e2855798699.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJBUfsd5BtsYkRco1UqUz5WXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c86e27fd-0d65-4ddf-a913-8f6cf6ccf542",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Regal Commonwealth",
      "poi_type": "Entertainment",
      "poi_address": "5001 Commonwealth Centre Pkwy, Midlothian, VA 23112, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-1fc6-74e1-a27a-248dac5c1253.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-1fc6-74e1-a27a-248dac5c1253",
        "storage_key": "property/6767906449166314/019fce39-1fc6-74e1-a27a-248dac5c1253.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-commonwealth-1864?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4686176534163867604&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-commonwealth",
      "poi_latitude": "37.41944",
      "poi_longitude": "-77.62887599999999",
      "poi_miles_from_property": "13.8 mi",
      "poi_walking_minutes": "5 hours 6 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d27e-715e-9611-4e2855798699.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d27e-715e-9611-4e2855798699",
        "storage_key": "property/6767906449166314/019d0265-d27e-715e-9611-4e2855798699.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJHUwv5IxzsYkR1MebubqkCEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6af4a44a-695f-49b3-bc44-0e2ec1b64d92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Science Museum of Virginia",
      "poi_type": "Entertainment",
      "poi_address": "2500 W Broad St, Richmond, VA 23220, USA",
      "poi_short_description": "Kid-focused, hands-on exhibits about animals, the human body, the cosmos & the environment.",
      "poi_long_description": "Kid-focused, hands-on exhibits about animals, the human body, the cosmos & the environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-2586-74fe-bef7-949740886d47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-2586-74fe-bef7-949740886d47",
        "storage_key": "property/6767906449166314/019fce39-2586-74fe-bef7-949740886d47.webp",
        "width": 1280,
        "height": 849
      },
      "poi_business_url": "http://www.smv.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10474820232218678101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "science-museum-of-virginia",
      "poi_latitude": "37.5610827",
      "poi_longitude": "-77.4657929",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 804-864-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d274-761a-83fd-b743fb666083.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d274-761a-83fd-b743fb666083",
        "storage_key": "property/6767906449166314/019d0265-d274-761a-83fd-b743fb666083.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJs9jmx1QRsYkRVRN404AJXpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_837ef8fe-b893-4d7a-84f4-e334c94d8f73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Virginia Museum of Fine Arts",
      "poi_type": "Entertainment",
      "poi_address": "200 N Arthur Ashe Blvd, Richmond, VA 23220, USA",
      "poi_short_description": "Museum with a varied, sizable collection of modern art, antiquities & Asian art, plus Fabergé eggs.",
      "poi_long_description": "Museum with a varied, sizable collection of modern art, antiquities & Asian art, plus Fabergé eggs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-2582-7493-97ba-44984908e621.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-2582-7493-97ba-44984908e621",
        "storage_key": "property/6767906449166314/019fce39-2582-7493-97ba-44984908e621.webp",
        "width": 681,
        "height": 458
      },
      "poi_business_url": "https://vmfa.museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4695707663755383770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-museum-of-fine-arts",
      "poi_latitude": "37.5560356",
      "poi_longitude": "-77.4747907",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 804-340-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d274-761a-83fd-b743fb666083.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d274-761a-83fd-b743fb666083",
        "storage_key": "property/6767906449166314/019d0265-d274-761a-83fd-b743fb666083.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJs1Bd8_wTsYkR2hM4wz2BKkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7e24a77e-65ce-4f9c-ae40-035f9a962d9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "The Byrd Theatre",
      "poi_type": "Entertainment",
      "poi_address": "2908 W Cary St, Richmond, VA 23221, USA",
      "poi_short_description": "An historic landmark, this opulent 1928 movie palace now shows second-run films in grand style.",
      "poi_long_description": "An historic landmark, this opulent 1928 movie palace now shows second-run films in grand style.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-2735-7567-a706-85862f3ea427.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-2735-7567-a706-85862f3ea427",
        "storage_key": "property/6767906449166314/019fce39-2735-7567-a706-85862f3ea427.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://byrdtheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9894436379511868258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-byrd-theatre",
      "poi_latitude": "37.552441",
      "poi_longitude": "-77.4778413",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-358-3056",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d27e-715e-9611-4e2855798699.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d27e-715e-9611-4e2855798699",
        "storage_key": "property/6767906449166314/019d0265-d27e-715e-9611-4e2855798699.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJd1T2xOQTsYkRYsuB1XYZUIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2af10040-b571-426f-ba66-7fc2c05a039c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Maymont",
      "poi_type": "Entertainment",
      "poi_address": "1700 Hampton St, Richmond, VA 23220, USA",
      "poi_short_description": "A 19th-century estate hosting events & tours of its Gilded Age mansion, gardens & wildlife center.",
      "poi_long_description": "A 19th-century estate hosting events & tours of its Gilded Age mansion, gardens & wildlife center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-277c-710b-9aa9-3415aefabe26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-277c-710b-9aa9-3415aefabe26",
        "storage_key": "property/6767906449166314/019fce39-277c-710b-9aa9-3415aefabe26.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://maymont.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4834827198225545156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maymont",
      "poi_latitude": "37.5341784",
      "poi_longitude": "-77.474571",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 804-525-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d27c-72fa-bb00-db807454bbaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d27c-72fa-bb00-db807454bbaa",
        "storage_key": "property/6767906449166314/019d0265-d27c-72fa-bb00-db807454bbaa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJI8TfDdkTsYkRxHehhLjBGEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b8a66c8c-4652-4293-9765-d2e6a9db85c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Dogwood Dell Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "600 S Arthur Ashe Blvd, Richmond, VA 23220, USA",
      "poi_short_description": "Site seating 2400 holds a summer-long festival of the arts that is a city cultural institution.",
      "poi_long_description": "Site seating 2400 holds a summer-long festival of the arts that is a city cultural institution.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-2c0c-73c6-9137-9d2dc911d06d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-2c0c-73c6-9137-9d2dc911d06d",
        "storage_key": "property/6767906449166314/019fce39-2c0c-73c6-9137-9d2dc911d06d.webp",
        "width": 1280,
        "height": 780
      },
      "poi_business_url": "https://rva.gov/parks-recreation/dogwood-dell",
      "poi_directions_map_url": "https://maps.google.com/?cid=2764901024641575350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dogwood-dell-amphitheater",
      "poi_latitude": "37.5408149",
      "poi_longitude": "-77.4825517",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-646-1437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cf6d-77aa-9439-53d9b8fc5b9c",
        "storage_key": "property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpy-F2MITsYkRtunfNNXmXiY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a0a0924b-65f9-4da0-a1bd-4e8391ef4331",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "The National",
      "poi_type": "Entertainment",
      "poi_address": "708 E Broad St, Richmond, VA 23219, USA",
      "poi_short_description": "Ornate, renovated 1920s theater now hosting medium-sized music shows & other performances.",
      "poi_long_description": "Ornate, renovated 1920s theater now hosting medium-sized music shows & other performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-2bfd-7639-87f5-35f359451479.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-2bfd-7639-87f5-35f359451479",
        "storage_key": "property/6767906449166314/019fce39-2bfd-7639-87f5-35f359451479.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thenationalva.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10004828295590865461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-national",
      "poi_latitude": "37.541897",
      "poi_longitude": "-77.43517",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 804-612-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cf6d-77aa-9439-53d9b8fc5b9c",
        "storage_key": "property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0UdhNiMRsYkRNWp4tVNK2Io",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7e176f80-1e7e-44cb-85fa-f9153bce042d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Central Virginia VA Health Care System",
      "poi_type": "Health and Wellness",
      "poi_address": "1201 Broad Rock Blvd, Richmond, VA 23249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-2d37-72bc-8009-09dd52cf5d81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-2d37-72bc-8009-09dd52cf5d81",
        "storage_key": "property/6767906449166314/019fce39-2d37-72bc-8009-09dd52cf5d81.webp",
        "width": 480,
        "height": 330
      },
      "poi_business_url": "https://www.va.gov/richmond-health-care/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12923795252491296979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-virginia-va-health-care-system",
      "poi_latitude": "37.4968557",
      "poi_longitude": "-77.467295",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 804-675-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d4c6-72d8-8099-645851875ac1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d4c6-72d8-8099-645851875ac1",
        "storage_key": "property/6767906449166314/019d0265-d4c6-72d8-8099-645851875ac1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJswC9YPQRsYkR06CfFk-LWrM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b4ae3235-3083-4cca-85a1-4bc027448f96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Chippenham Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "7101 Jahnke Rd E, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-2dad-70c6-a201-b606cdbc4830.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-2dad-70c6-a201-b606cdbc4830",
        "storage_key": "property/6767906449166314/019fce39-2dad-70c6-a201-b606cdbc4830.webp",
        "width": 888,
        "height": 499
      },
      "poi_business_url": "https://www.hcavirginia.com/locations/chippenham-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7643199243469856749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chippenham-hospital",
      "poi_latitude": "37.5135368",
      "poi_longitude": "-77.5261508",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 804-483-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d843-7258-80d8-4f354f7abc7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d843-7258-80d8-4f354f7abc7f",
        "storage_key": "property/6767906449166314/019d0265-d843-7258-80d8-4f354f7abc7f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2uycvASsYkR7R-ObjcZEmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bd29f35c-3f76-4ef7-b29b-d2f8ef4ab4ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Bon Secours Urgent Care, Towne Center",
      "poi_type": "Health and Wellness",
      "poi_address": "11603 Midlothian Tpke Towne Center, Midlothian, VA 23113, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-3237-76fc-9eff-4a847a910aa8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-3237-76fc-9eff-4a847a910aa8",
        "storage_key": "property/6767906449166314/019fce39-3237-76fc-9eff-4a847a910aa8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bonsecours.com/locations/walk-in-urgent-care/richmond/bon-secours-urgent-care-towne-center?utm_source=google&utm_medium=organic&utm_content=local_website_link",
      "poi_directions_map_url": "https://maps.google.com/?cid=6142502550761684361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bon-secours-urgent-care-towne-center",
      "poi_latitude": "37.5046148",
      "poi_longitude": "-77.6125169",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 804-378-3739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cf6d-77aa-9439-53d9b8fc5b9c",
        "storage_key": "property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSdeQs5xtsYkRib0UioaNPlU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_83a647a4-c5a1-4d4d-a857-f0376d9fa791",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "JenCare Senior Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "6530 Hull Street Rd, Richmond, VA 23224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-3326-7429-98a9-5ea63fe5c372.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-3326-7429-98a9-5ea63fe5c372",
        "storage_key": "property/6767906449166314/019fce39-3326-7429-98a9-5ea63fe5c372.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.jencaremed.com/find-a-location/richmond-virginia/hull-street/?utm_source=google&utm_medium=organic&utm_campaign=chenmed_local_listing&utm_content=gbp_hullstreet&y_source=1_Mzk0OTU2Ny03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9296496917491444996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jencare-senior-medical-center",
      "poi_latitude": "37.4807165",
      "poi_longitude": "-77.5135026",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-674-3425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cf6d-77aa-9439-53d9b8fc5b9c",
        "storage_key": "property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf_vADYENsYkRBG2XBrHKA4E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ed3a979b-8731-44ce-a9f3-08901dbfc365",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5122 Hull Street Rd, Richmond, VA 23224, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-33a7-768b-89bc-a918b8d8bb5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-33a7-768b-89bc-a918b8d8bb5a",
        "storage_key": "property/6767906449166314/019fce39-33a7-768b-89bc-a918b8d8bb5a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-5122+hull+street+rd-richmond-va-23224/id=3682",
      "poi_directions_map_url": "https://maps.google.com/?cid=17190396246760434494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "37.49351559999999",
      "poi_longitude": "-77.48796159999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 804-232-4399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d845-7751-b95b-f2edb3acbc0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d845-7751-b95b-f2edb3acbc0a",
        "storage_key": "property/6767906449166314/019d0265-d845-7751-b95b-f2edb3acbc0a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWd3ULRISsYkRPitdzE6OkO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ac5b1024-8fc2-4619-803b-31b5ac9e7e5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "4715 Walmsley Blvd, Richmond, VA 23234, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-33bd-734c-8c27-91489a1ac289.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-33bd-734c-8c27-91489a1ac289",
        "storage_key": "property/6767906449166314/019fce39-33bd-734c-8c27-91489a1ac289.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/richmond-va-pharmacies/4715-walmsley-boulevard-corner-of-wamsley-and-broad-rock-richmond-va-23234/storeid=1971?WT.mc_id=LS_GOOGLE_FS_1971",
      "poi_directions_map_url": "https://maps.google.com/?cid=11337638298275382086&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "37.4690757",
      "poi_longitude": "-77.48252889999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-275-9235",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cf6d-77aa-9439-53d9b8fc5b9c",
        "storage_key": "property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBQbrG_ANsYkRRoORgPZhV50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ab27d926-fd16-4cf8-b6cc-62e34d80c15e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "6400 Iron Bridge Rd, Richmond, VA 23234, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-3931-73ce-a436-1e6e3ae8c848.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-3931-73ce-a436-1e6e3ae8c848",
        "storage_key": "property/6767906449166314/019fce39-3931-73ce-a436-1e6e3ae8c848.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/richmond-va-pharmacies/6400-iron-bridge-rd-richmond-va-23234/storeid=1525?WT.mc_id=LS_GOOGLE_RX_1525",
      "poi_directions_map_url": "https://maps.google.com/?cid=441770833996239323&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "37.4294001",
      "poi_longitude": "-77.4935383",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 804-271-8361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d845-7751-b95b-f2edb3acbc0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d845-7751-b95b-f2edb3acbc0a",
        "storage_key": "property/6767906449166314/019d0265-d845-7751-b95b-f2edb3acbc0a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsbZtBEgMsYkR21F5oDt8IQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ab97f030-d027-445e-9bd7-3ee602fccba1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Gold's Gym Westchester Commons",
      "poi_type": "Health and Wellness",
      "poi_address": "345 Schofield Dr, Midlothian, VA 23113, USA",
      "poi_short_description": "Chain gym offering a smoothie bar, a pool, an indoor basketball court, and a kids' club.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-39ba-70ca-9a2e-c9ec3d05cd04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-39ba-70ca-9a2e-c9ec3d05cd04",
        "storage_key": "property/6767906449166314/019fce39-39ba-70ca-9a2e-c9ec3d05cd04.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.goldsgym.com/richmondmidlothianva/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13191641970085722875&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golds-gym-westchester-commons",
      "poi_latitude": "37.5163313",
      "poi_longitude": "-77.6940109",
      "poi_miles_from_property": "13.2 mi",
      "poi_walking_minutes": "4 hours 56 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 804-379-5690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cf6d-77aa-9439-53d9b8fc5b9c",
        "storage_key": "property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_ee8qxBusYkR-_oXv3ogErc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2a9e4c6b-93eb-40ad-bcdc-e603caa8b690",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "11001 Hull Street Rd N, Midlothian, VA 23112, USA",
      "poi_short_description": "Membership-based chain with a warm atmosphere, cardio equipment and tanning beds among other amenities.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-39aa-77fd-96b1-59c50e47861c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-39aa-77fd-96b1-59c50e47861c",
        "storage_key": "property/6767906449166314/019fce39-39aa-77fd-96b1-59c50e47861c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/midlothian-va?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1618581211304971230&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "37.4368366",
      "poi_longitude": "-77.5960537",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-658-3089",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cf6d-77aa-9439-53d9b8fc5b9c",
        "storage_key": "property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9a5DsA9zsYkR3kv0OwlbdhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c98e8df1-c905-4d49-8854-ee3eb78db428",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Healthy Life Yoga LLC",
      "poi_type": "Health and Wellness",
      "poi_address": "13565 Midlothian Tpke, Midlothian, VA 23113, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-3a5a-716d-8f7a-33a88129357b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-3a5a-716d-8f7a-33a88129357b",
        "storage_key": "property/6767906449166314/019fce39-3a5a-716d-8f7a-33a88129357b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.healthylifeyogallc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16085148395705516524&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "healthy-life-yoga-llc",
      "poi_latitude": "37.5018622",
      "poi_longitude": "-77.65097569999999",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 804-437-0608",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cdd9-72ed-8aa4-8df02c84aafc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cdd9-72ed-8aa4-8df02c84aafc",
        "storage_key": "property/6767906449166314/019d0265-cdd9-72ed-8aa4-8df02c84aafc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO1QLzSJusYkR7MF4PT7tOd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ddfddd0f-5cb4-4045-b624-6adf8ac44020",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Robious Landing Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3800 James River Rd, Midlothian, VA 23113, USA",
      "poi_short_description": "Well-maintained trails, a boat launch and a dock for canoeing and kayaking along the James River.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-4083-70ac-a8a8-c2a5843ddcd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-4083-70ac-a8a8-c2a5843ddcd8",
        "storage_key": "property/6767906449166314/019fce39-4083-70ac-a8a8-c2a5843ddcd8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chesterfield.gov/150/Parks-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=9898839394627477067&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robious-landing-park",
      "poi_latitude": "37.5576841",
      "poi_longitude": "-77.650033",
      "poi_miles_from_property": "12.8 mi",
      "poi_walking_minutes": "4 hours 42 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 804-748-1623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d27c-72fa-bb00-db807454bbaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d27c-72fa-bb00-db807454bbaa",
        "storage_key": "property/6767906449166314/019d0265-d27c-72fa-bb00-db807454bbaa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnYIr4iBssYkRS95prfu9X4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0ca31c9f-db96-4c7e-ba85-450aaf542a72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Huguenot Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10901 Robious Rd, Richmond, VA 23235, USA",
      "poi_short_description": "53-acred wooded park featuring a play lot, sports fields, basketball & tennis courts, trails & more.",
      "poi_long_description": "53-acred wooded park featuring a play lot, sports fields, basketball & tennis courts, trails & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-410a-740a-9075-e7c26053f800.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-410a-740a-9075-e7c26053f800",
        "storage_key": "property/6767906449166314/019fce39-410a-740a-9075-e7c26053f800.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chesterfield.gov/Facilities/Facility/Details/Huguenot-Park-53",
      "poi_directions_map_url": "https://maps.google.com/?cid=7984569737700845474&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "huguenot-park",
      "poi_latitude": "37.5148538",
      "poi_longitude": "-77.5985965",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 804-748-1892",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d27c-72fa-bb00-db807454bbaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d27c-72fa-bb00-db807454bbaa",
        "storage_key": "property/6767906449166314/019d0265-d27c-72fa-bb00-db807454bbaa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjTUKag1tsYkRoif-U9_jzm4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4de2ff6c-5ffb-4666-b128-081a6a3eb1d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Dorey Park and Recreation Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2999 Darbytown Rd, Henrico, VA 23231, USA",
      "poi_short_description": "Nature area & pond with trails, playground, gazebo & picnic shelters plus an off-leash dog park.",
      "poi_long_description": "Nature area & pond with trails, playground, gazebo & picnic shelters plus an off-leash dog park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-4131-735e-b6df-d12538ccffdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-4131-735e-b6df-d12538ccffdd",
        "storage_key": "property/6767906449166314/019fce39-4131-735e-b6df-d12538ccffdd.webp",
        "width": 1080,
        "height": 821
      },
      "poi_business_url": "http://henrico.gov/rec/places/dorey/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5852147895589750631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dorey-park-and-recreation-center",
      "poi_latitude": "37.4650432",
      "poi_longitude": "-77.3401416",
      "poi_miles_from_property": "15.8 mi",
      "poi_walking_minutes": "5 hours 48 mins",
      "poi_biking_minutes": "1 hour 34 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 804-652-1440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d27c-72fa-bb00-db807454bbaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d27c-72fa-bb00-db807454bbaa",
        "storage_key": "property/6767906449166314/019d0265-d27c-72fa-bb00-db807454bbaa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJTcdtOtMasYkRZ0etSYEBN1E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5cef6eb1-e158-401a-86f9-d2d5bd35924b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Rockwood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3401 Courthouse Rd, Richmond, VA 23236, USA",
      "poi_short_description": "Public green space with archery, softball, basketball & tennis plus a playground, trail & dog park.",
      "poi_long_description": "Public green space with archery, softball, basketball & tennis plus a playground, trail & dog park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-41b5-7467-8b2a-9842f802d45e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-41b5-7467-8b2a-9842f802d45e",
        "storage_key": "property/6767906449166314/019fce39-41b5-7467-8b2a-9842f802d45e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chesterfield.gov/3824/Rockwood-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14436087448396485264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockwood-park",
      "poi_latitude": "37.4481749",
      "poi_longitude": "-77.5823319",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 804-276-6661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d27c-72fa-bb00-db807454bbaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d27c-72fa-bb00-db807454bbaa",
        "storage_key": "property/6767906449166314/019d0265-d27c-72fa-bb00-db807454bbaa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ2GKft9ysYkRkNIldAxJV8g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5753cb18-cf5d-48aa-8990-776fd63981b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "James River Park Pony Pasture",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Richmond, VA 23225, USA",
      "poi_short_description": "Riverside park featuring scenic trails for biking and hiking, as well as swimming.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-4810-746e-84dc-65f8a80ba85c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-4810-746e-84dc-65f8a80ba85c",
        "storage_key": "property/6767906449166314/019fce39-4810-746e-84dc-65f8a80ba85c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://jamesriverpark.org/explore-the-park-pony-pasture/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12267777557924412234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-river-park-pony-pasture",
      "poi_latitude": "37.5506636",
      "poi_longitude": "-77.51756619999999",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d27c-72fa-bb00-db807454bbaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d27c-72fa-bb00-db807454bbaa",
        "storage_key": "property/6767906449166314/019d0265-d27c-72fa-bb00-db807454bbaa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgXjOv3UTsYkRSvuXA7HmP6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_899f3fd4-1e93-416c-ae52-de7a4123c80f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Huguenot Flatwater - James River Park System",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8600 Southampton Rd, Richmond, VA 23235, USA",
      "poi_short_description": "37 acres under the Huguenot Bridge with birdwatching, a boat ramp & paths for bank fishing.",
      "poi_long_description": "37 acres under the Huguenot Bridge with birdwatching, a boat ramp & paths for bank fishing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-48ed-7183-b9ac-f0536293a4ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-48ed-7183-b9ac-f0536293a4ea",
        "storage_key": "property/6767906449166314/019fce39-48ed-7183-b9ac-f0536293a4ea.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://jamesriverpark.org/explore-the-park-huguenot-flatwater/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13530647582163216593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "huguenot-flatwater---james-river-park-system",
      "poi_latitude": "37.5599797",
      "poi_longitude": "-77.5457366",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-646-8911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d27c-72fa-bb00-db807454bbaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d27c-72fa-bb00-db807454bbaa",
        "storage_key": "property/6767906449166314/019d0265-d27c-72fa-bb00-db807454bbaa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHRB1OEMTsYkR0SjWm0mExrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7eed5e7b-6363-44b7-b1e4-27e17786de74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Forest Hill Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4021 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "Partial wetland area with a historic home, nature trails, wildlife, tennis courts, picnics & events.",
      "poi_long_description": "Partial wetland area with a historic home, nature trails, wildlife, tennis courts, picnics & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-49a9-7428-9d3a-41144bf60198.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-49a9-7428-9d3a-41144bf60198",
        "storage_key": "property/6767906449166314/019fce39-49a9-7428-9d3a-41144bf60198.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.rva.gov/parks-recreation/forest-hill-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4852190897879243188&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "forest-hill-park",
      "poi_latitude": "37.5207992",
      "poi_longitude": "-77.4763246",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-646-0036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d27c-72fa-bb00-db807454bbaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d27c-72fa-bb00-db807454bbaa",
        "storage_key": "property/6767906449166314/019d0265-d27c-72fa-bb00-db807454bbaa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMQ1A5CoSsYkRtNl54ulxVkM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e5b518ae-1182-47fe-b40d-4b7cec89978e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Bensley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2900 Drewrys Bluff Rd, Richmond, VA 23237, USA",
      "poi_short_description": "Playground, baseball field, and soccer field in a well-maintained park.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-494a-7335-8a9a-2fa484965f55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-494a-7335-8a9a-2fa484965f55",
        "storage_key": "property/6767906449166314/019fce39-494a-7335-8a9a-2fa484965f55.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chesterfield.gov/Facilities/Facility/Details/Bensley-Park-35",
      "poi_directions_map_url": "https://maps.google.com/?cid=619001017340783930&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bensley-park",
      "poi_latitude": "37.4290546",
      "poi_longitude": "-77.4452823",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 804-748-1623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d27c-72fa-bb00-db807454bbaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d27c-72fa-bb00-db807454bbaa",
        "storage_key": "property/6767906449166314/019d0265-d27c-72fa-bb00-db807454bbaa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFwdPe_MOsYkROu0zSiUilwg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6cd0d8fa-b2e2-496b-a25c-86e372a24e99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Pocahontas State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10301 State Park Rd, Chesterfield, VA 23832, USA",
      "poi_short_description": "An 8,000-acre park offering hiking, biking & horse trails, plus 2 fishing lakes & an aquatic center.",
      "poi_long_description": "An 8,000-acre park offering hiking, biking & horse trails, plus 2 fishing lakes & an aquatic center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-4fd7-71d0-979c-2bfea9e6f5eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-4fd7-71d0-979c-2bfea9e6f5eb",
        "storage_key": "property/6767906449166314/019fce39-4fd7-71d0-979c-2bfea9e6f5eb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.dcr.virginia.gov/state-parks/pocahontas.shtml",
      "poi_directions_map_url": "https://maps.google.com/?cid=450592607913044015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pocahontas-state-park",
      "poi_latitude": "37.3724285",
      "poi_longitude": "-77.57153199999999",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 804-796-4255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d27c-72fa-bb00-db807454bbaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d27c-72fa-bb00-db807454bbaa",
        "storage_key": "property/6767906449166314/019d0265-d27c-72fa-bb00-db807454bbaa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJr2SslsB0sYkRL-gS7ZbTQAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0e13f816-efa1-4add-be78-bf68b575ed6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "11801 Womack Rd",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11801 Womack Rd, Chester, VA 23831, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14724185330019275806&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "11801-womack-rd",
      "poi_latitude": "37.3595309",
      "poi_longitude": "-77.4536123",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 18 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cf6d-77aa-9439-53d9b8fc5b9c",
        "storage_key": "property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkyG8d3EJsYkRHhTRqovQVsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cc675fa9-e542-4170-8846-0a6570c3d26e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Richmond Main Street Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1500 E Main St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-4f7c-73da-8044-f503e7b4d2e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-4f7c-73da-8044-f503e7b4d2e2",
        "storage_key": "property/6767906449166314/019fce39-4f7c-73da-8044-f503e7b4d2e2.webp",
        "width": 1280,
        "height": 1237
      },
      "poi_business_url": "https://www.amtrak.com/stations/rvm.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11973413221483929113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-main-street-station",
      "poi_latitude": "37.5351005",
      "poi_longitude": "-77.4287069",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cf6d-77aa-9439-53d9b8fc5b9c",
        "storage_key": "property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX8r0xR4RsYkRGd6DF-MbKqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_41edc202-5f16-4bb0-a3c3-39600ea998e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Richmond Staples Mill Road",
      "poi_type": "Transportation & Transit",
      "poi_address": "7519 Staples Mill Rd, Richmond, VA 23228, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-500c-72c3-811b-46a3323c28cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-500c-72c3-811b-46a3323c28cf",
        "storage_key": "property/6767906449166314/019fce39-500c-72c3-811b-46a3323c28cf.webp",
        "width": 1280,
        "height": 871
      },
      "poi_business_url": "https://www.amtrak.com/stations/rvr",
      "poi_directions_map_url": "https://maps.google.com/?cid=5387222506202384095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-staples-mill-road",
      "poi_latitude": "37.6177745",
      "poi_longitude": "-77.49697019999999",
      "poi_miles_from_property": "13.4 mi",
      "poi_walking_minutes": "5 hours 0 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cf6d-77aa-9439-53d9b8fc5b9c",
        "storage_key": "property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJubZoY7cVsYkR38YuoFNCw0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ec6ed909-73a7-4543-b386-39f8bfb07f0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Richmond International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Richard E Byrd Terminal Dr, Richmond, VA 23250, USA",
      "poi_short_description": "Opened in 1927, this airport close to Virginia's capital offers free WiFi & mostly domestic flights.",
      "poi_long_description": "Opened in 1927, this airport close to Virginia's capital offers free WiFi & mostly domestic flights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-50b4-71ff-8e7f-ac47625dd2fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-50b4-71ff-8e7f-ac47625dd2fc",
        "storage_key": "property/6767906449166314/019fce39-50b4-71ff-8e7f-ac47625dd2fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://flyrichmond.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6449714593814021840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-international-airport",
      "poi_latitude": "37.5105562",
      "poi_longitude": "-77.3266991",
      "poi_miles_from_property": "14.6 mi",
      "poi_walking_minutes": "5 hours 26 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 804-226-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d8d4-7448-a238-225b75ed3e00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d8d4-7448-a238-225b75ed3e00",
        "storage_key": "property/6767906449166314/019d0265-d8d4-7448-a238-225b75ed3e00.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dzDsqwbsYkR0AbwQkD9gVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d14c80d5-7de8-4730-92cd-5dfdd98047b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "GRTC",
      "poi_type": "Transportation & Transit",
      "poi_address": "301 E Belt Blvd, Richmond, VA 23224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-5570-743a-995d-82911651a28c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-5570-743a-995d-82911651a28c",
        "storage_key": "property/6767906449166314/019fce39-5570-743a-995d-82911651a28c.webp",
        "width": 1000,
        "height": 380
      },
      "poi_business_url": "http://www.ridegrtc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16451363726910217568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grtc",
      "poi_latitude": "37.5066205",
      "poi_longitude": "-77.478867",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 804-358-4782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cf6d-77aa-9439-53d9b8fc5b9c",
        "storage_key": "property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ2E1riESsYkRYN06hSX8TuQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b583455f-eba1-4f1a-a7a1-64d873f5bc7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "RideFinders",
      "poi_type": "Transportation & Transit",
      "poi_address": "1013 E Main St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-5634-74aa-899a-1b49ac314e1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-5634-74aa-899a-1b49ac314e1f",
        "storage_key": "property/6767906449166314/019fce39-5634-74aa-899a-1b49ac314e1f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ridefinders.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17457098239546745791&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridefinders",
      "poi_latitude": "37.5372101",
      "poi_longitude": "-77.43498939999999",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 804-643-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cf6d-77aa-9439-53d9b8fc5b9c",
        "storage_key": "property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW7iNPRgRsYkRv-NHcVsSRPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8b978bdc-4937-49df-912b-6cdc8acc520c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Chesterfield Towne Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "11500 Midlothian Tpke, Richmond, VA 23235, USA",
      "poi_short_description": "Sprawling shopping complex offering more than 100 retailers, plus restaurants & snack shops.",
      "poi_long_description": "Sprawling shopping complex offering more than 100 retailers, plus restaurants & snack shops.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-5707-7115-85d1-a8e4f9b57149.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-5707-7115-85d1-a8e4f9b57149",
        "storage_key": "property/6767906449166314/019fce39-5707-7115-85d1-a8e4f9b57149.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chesterfieldcenter.com/en?cmpid=lc_yext_yext_other_o_none&utm_medium=local&utm_source=other&utm_content=none",
      "poi_directions_map_url": "https://maps.google.com/?cid=7803157530636599063&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chesterfield-towne-center",
      "poi_latitude": "37.5086181",
      "poi_longitude": "-77.609051",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 804-794-4662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-daf5-742f-a451-4992e401f382.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-daf5-742f-a451-4992e401f382",
        "storage_key": "property/6767906449166314/019d0265-daf5-742f-a451-4992e401f382.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYS5n751tsYkRFz8CZG5iSmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8f50cf7e-eb5e-4c96-b156-732d6517af79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "U.S. 360 & Hull Street Road",
      "poi_type": "Transportation & Transit",
      "poi_address": "US-360 & Hull Street Rd, Richmond, VA 23224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?q=US-360+%26+Hull+Street+Rd,+Richmond,+VA+23224,+USA&ftid=0x89b111055fd1e6a9:0x99d98de14065e9b6&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "us-360--hull-street-road",
      "poi_latitude": "37.5263215",
      "poi_longitude": "-77.4356348",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cf6d-77aa-9439-53d9b8fc5b9c",
        "storage_key": "property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "EjBVUy0zNjAgJiBIdWxsIFN0cmVldCBSZCwgUmljaG1vbmQsIFZBIDIzMjI0LCBVU0EiZiJkChQKEgmp5tFfBRGxiRG26WVA4Y3ZmRIUChIJqebRXwURsYkRtullQOGN2ZkaFAoSCVWp0rPkg7GJEX88kSJQQuajGhQKEgkhLI4SnBGxiRET8Vb_zcu_biIKDe8PXhYVhELY0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5ff9b94b-3534-4870-88d7-b7a8d97be3aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Chippenham Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7101 Jahnke Rd E, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-2dad-70c6-a201-b606cdbc4830.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-2dad-70c6-a201-b606cdbc4830",
        "storage_key": "property/6767906449166314/019fce39-2dad-70c6-a201-b606cdbc4830.webp",
        "width": 888,
        "height": 499
      },
      "poi_business_url": "https://www.hcavirginia.com/locations/chippenham-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7643199243469856749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chippenham-hospital",
      "poi_latitude": "37.5135368",
      "poi_longitude": "-77.5261508",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 804-483-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d843-7258-80d8-4f354f7abc7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d843-7258-80d8-4f354f7abc7f",
        "storage_key": "property/6767906449166314/019d0265-d843-7258-80d8-4f354f7abc7f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2uycvASsYkR7R-ObjcZEmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9d3659f7-a422-4247-87d0-bbe8f76cc9e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "VCU Medical Center Main Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1250 E Marshall St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-5709-76a4-a520-b8b104d443e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-5709-76a4-a520-b8b104d443e2",
        "storage_key": "property/6767906449166314/019fce39-5709-76a4-a520-b8b104d443e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.vcuhealth.org/locations/location-details?practice=10",
      "poi_directions_map_url": "https://maps.google.com/?cid=16171533531014720203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vcu-medical-center-main-hospital",
      "poi_latitude": "37.5404994",
      "poi_longitude": "-77.4304837",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 804-828-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d843-7258-80d8-4f354f7abc7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d843-7258-80d8-4f354f7abc7f",
        "storage_key": "property/6767906449166314/019d0265-d843-7258-80d8-4f354f7abc7f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJHcj3gSERsYkRy2pz5RDUbOA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b2b3807e-24ac-4026-a683-7c4bcb1e8aea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Bon Secours St. Mary's Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5801 Bremo Rd, Richmond, VA 23226, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-5cde-764a-bdc2-63172e213f08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-5cde-764a-bdc2-63172e213f08",
        "storage_key": "property/6767906449166314/019fce39-5cde-764a-bdc2-63172e213f08.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.bonsecours.com/locations/hospitals-medical-centers/richmond/st-marys-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=15600236463638216957&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bon-secours-st-marys-hospital",
      "poi_latitude": "37.5842533",
      "poi_longitude": "-77.5127366",
      "poi_miles_from_property": "11.2 mi",
      "poi_walking_minutes": "4 hours 12 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 804-285-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d843-7258-80d8-4f354f7abc7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d843-7258-80d8-4f354f7abc7f",
        "storage_key": "property/6767906449166314/019d0265-d843-7258-80d8-4f354f7abc7f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJBUGmEmEUsYkR_YBA-2gsf9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_77d395c2-c8fd-47fc-91be-a181b9ac8970",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "DuPont",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5401 Jefferson Davis Hwy, Richmond, VA 23234, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-5c8d-77b9-bdc1-9e6e16ab8f6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-5c8d-77b9-bdc1-9e6e16ab8f6f",
        "storage_key": "property/6767906449166314/019fce39-5c8d-77b9-bdc1-9e6e16ab8f6f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.dupont.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2627728672073930152&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dupont",
      "poi_latitude": "37.4524449",
      "poi_longitude": "-77.4381136",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 804-383-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cf6d-77aa-9439-53d9b8fc5b9c",
        "storage_key": "property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD8gFtEYOsYkRqFUTEU6RdyQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_79daf86a-4523-4ada-aaef-1ddd46846848",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Altria Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6601 W Broad St, Richmond, VA 23230, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-5dc1-764e-8adc-193eabe13f15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-5dc1-764e-8adc-193eabe13f15",
        "storage_key": "property/6767906449166314/019fce39-5dc1-764e-8adc-193eabe13f15.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.altria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14996391984863159021&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "altria-headquarters",
      "poi_latitude": "37.6007695",
      "poi_longitude": "-77.5169708",
      "poi_miles_from_property": "12.8 mi",
      "poi_walking_minutes": "4 hours 49 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cf6d-77aa-9439-53d9b8fc5b9c",
        "storage_key": "property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJITmtbfgUsYkR7aJIUg7jHdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_57898332-8bbd-440d-bf7d-05963075a4ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Federal Reserve Bank of Richmond",
      "poi_type": "Major Employers & Offices",
      "poi_address": "701 E Byrd St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-5de5-7671-a08f-909a9fa76530.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-5de5-7671-a08f-909a9fa76530",
        "storage_key": "property/6767906449166314/019fce39-5de5-7671-a08f-909a9fa76530.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.richmondfed.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6660900425225583294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "federal-reserve-bank-of-richmond",
      "poi_latitude": "37.5355285",
      "poi_longitude": "-77.4406827",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-697-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d4c6-72d8-8099-645851875ac1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d4c6-72d8-8099-645851875ac1",
        "storage_key": "property/6767906449166314/019d0265-d4c6-72d8-8099-645851875ac1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf2VtkBYRsYkRvrrRUaVFcFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8fe01819-f537-4b5a-9510-4e958b972d56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "RIC2 Amazon Fullfillment Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Amazon Fulfillment Center, 1901 Meadowville Technology Pkwy, Chester, VA 23836, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-6356-72ce-bb62-6433447e53d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-6356-72ce-bb62-6433447e53d0",
        "storage_key": "property/6767906449166314/019fce39-6356-72ce-bb62-6433447e53d0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17975451964194764886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ric2-amazon-fullfillment-center",
      "poi_latitude": "37.3521481",
      "poi_longitude": "-77.3268579",
      "poi_miles_from_property": "20.1 mi",
      "poi_walking_minutes": "7 hours 20 mins",
      "poi_biking_minutes": "1 hour 40 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 804-541-2019",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cf6d-77aa-9439-53d9b8fc5b9c",
        "storage_key": "property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2QZhf_EGsYkRVjjtylKidfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bcb7d9d1-3c7e-4ec6-b112-dc623dfd0f7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Owens & Minor",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10900 Nuckols Rd #400, Glen Allen, VA 23060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6379522244480428511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "owens--minor",
      "poi_latitude": "37.6664991",
      "poi_longitude": "-77.57322020000001",
      "poi_miles_from_property": "19.1 mi",
      "poi_walking_minutes": "7 hours 5 mins",
      "poi_biking_minutes": "1 hour 53 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cf6d-77aa-9439-53d9b8fc5b9c",
        "storage_key": "property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIwPoHQBBsYkR32n1Yq6diFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ae9aa19b-83c2-4b8e-8a02-2eea0894c0c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "9800 Government Center Pkwy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9800 Government Center Pkwy, Chesterfield, VA 23832, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11025839966773271204&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "9800-government-center-pkwy",
      "poi_latitude": "37.3790924",
      "poi_longitude": "-77.5057271",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cf6d-77aa-9439-53d9b8fc5b9c",
        "storage_key": "property/6767906449166314/019d0265-cf6d-77aa-9439-53d9b8fc5b9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCwC1PpgLsYkRpFrTSQinA5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_175b56c3-cb46-4acc-838a-610286257125",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "poi_name": "Richmond International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Richard E Byrd Terminal Dr, Richmond, VA 23250, USA",
      "poi_short_description": "Opened in 1927, this airport close to Virginia's capital offers free WiFi & mostly domestic flights.",
      "poi_long_description": "Opened in 1927, this airport close to Virginia's capital offers free WiFi & mostly domestic flights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019fce39-50b4-71ff-8e7f-ac47625dd2fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce39-50b4-71ff-8e7f-ac47625dd2fc",
        "storage_key": "property/6767906449166314/019fce39-50b4-71ff-8e7f-ac47625dd2fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://flyrichmond.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6449714593814021840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-international-airport",
      "poi_latitude": "37.5105562",
      "poi_longitude": "-77.3266991",
      "poi_miles_from_property": "14.6 mi",
      "poi_walking_minutes": "5 hours 26 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 804-226-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0265-d8d4-7448-a238-225b75ed3e00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d8d4-7448-a238-225b75ed3e00",
        "storage_key": "property/6767906449166314/019d0265-d8d4-7448-a238-225b75ed3e00.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dzDsqwbsYkR0AbwQkD9gVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_88e0f016b82b2f5f7102086e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6f2e8997ec635d6f9b467cd2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_4b478203fb0f7b4aeac5a401",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_1a00996a0d86969c953d7db1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c9101c13803e577f3ca54b66",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_22aa6e1ec7a45916a88796cf",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_42f194159b6584d8c1e68a2a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "rating": "5",
      "name": "Tamara Bonds",
      "text": "I’ve lived at Chesterfield Flats for 2 years and 4 months, and my experience has been very pleasant. Maintenance requests are always handled quickly, usually the same day or by the next day.\n\nI really enjoy the amenities.Especially the pool and gym. The gym is one of my favorite features, and I’m glad we have it. We have recently received trash services - very awesome. I also appreciate the safe, secure neighborhood that’s perfect for daily walks. Having my own washer and dryer in-unit has been a huge convenience, too.\n\nThe property has continued to improve with many new renovations. Kathleen, Miesha, Yaya, Nick and Rich continue to show outstanding customer service. I plan to stay here for another year until I graduate. Overall, Chesterfield Flats has been a great place to call home, and I’d love for you to consider joining me as a neighbor! 🏳️‍🌈",
      "date": "2025-09-25",
      "title": "false"
    },
    {
      "id": "ec_a7c8717c258a9d1f86e4e7b6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "rating": "5",
      "name": "natajah lewis",
      "text": "Natasha Lewis apartment 3 104B\nI really enjoyed the breakfast that you were all giving out this morning. It was very helpful. Didn’t have to go get any snacks. I enjoy the pool area. I don’t like how you all are making trash. Mandatory out of the blue adding things onto someone’s rent  but I get it. And I’m glad you all kicked out the neighbors that were shooting at four in the morning",
      "date": "2025-09-28",
      "title": "false"
    },
    {
      "id": "ec_e4c11486c4d240d6e05b41e6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "rating": "5",
      "name": "Michael Williams",
      "text": "I have been a resident her for 9 years. The office and maintenance staff have always been so good to me. Kathleen and Yaya along with Miesha have helped me out so many different times. I absolutely love all the upgrades to the property. I have no plans on leaving anytime soon. I invite anyone to come be a resident here at chesterfield flats",
      "date": "2025-09-25",
      "title": "false"
    },
    {
      "id": "ec_0c42d07d44a365b0ab853681",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "rating": "5",
      "name": "Janequa Forbes",
      "text": "Very hard working individuals! will help you solve any issues or problems you have. Very kind and caring people the last 41/2 years I have been living there",
      "date": "2025-09-25",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_401a0aea53105d9e26efc864",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0266-5f98-72c1-962d-041f3b34f3b0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with white cabinets, granite countertops, stainless steel sink, black gas range, and black microwave.",
        "public_id": "019d0266-5f98-72c1-962d-041f3b34f3b0",
        "storage_key": "property/6767906449166314/019d0266-5f98-72c1-962d-041f3b34f3b0.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "2BR, 1BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=pFCpTYyCEmX"
    },
    {
      "id": "ec_c9528edd123029fe806e5140",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0266-5fa7-7507-b1a6-0acbbfbc22fb.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with teal accent wall, large clock, and decorative furniture.",
        "public_id": "019d0266-5fa7-7507-b1a6-0acbbfbc22fb",
        "storage_key": "property/6767906449166314/019d0266-5fa7-7507-b1a6-0acbbfbc22fb.webp",
        "width": 1000,
        "height": 563
      },
      "virtual_tour_title": "ChesterField Flats Model",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=2URRXSFuiQD"
    },
    {
      "id": "ec_34e8cef64484ddbe2252e1be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0266-f877-707e-b45b-a4e8ba0d3ef2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Interior living area with carpet and tile flooring, and a ceiling fan.",
        "public_id": "019d0266-f877-707e-b45b-a4e8ba0d3ef2",
        "storage_key": "property/6767906449166314/019d0266-f877-707e-b45b-a4e8ba0d3ef2.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR, 1.5BA - 1032 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=d1nVBXyz4t1"
    },
    {
      "id": "ec_b56776d0aad8c3e6347d8a19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/019d0266-6b64-7760-9174-0970bbc35b52.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and dining room area with beige carpet and white walls.",
        "public_id": "019d0266-6b64-7760-9174-0970bbc35b52",
        "storage_key": "property/6767906449166314/019d0266-6b64-7760-9174-0970bbc35b52.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "1BR, 1BA - 600 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=o1MWEpf8Uy1"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_cb3079a50d25b1e58df3b5a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "engrain",
      "external_id": "392309",
      "name": "Reservation Fee",
      "description": "Reservation Holding Fee",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_dd9595ee031880153d1094e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "engrain",
      "external_id": "392312",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8a074e74c4cbf46b961710d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "engrain",
      "external_id": "392313",
      "name": "Pet Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c88e5e6736c92a806d1e68be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "engrain",
      "external_id": "392314",
      "name": "Valet Trash",
      "description": "false",
      "amount": 15,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e90271a3171d1d2d4ee921a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "engrain",
      "external_id": "392315",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2f90242a8118f9383e6f90ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "engrain",
      "external_id": "392316",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_ad8b664e6fc20759f60bed6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "engrain",
      "external_id": "392317",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 300,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_efef44997426c41d2c3121af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "engrain",
      "external_id": "392319",
      "name": "Transfer Fee",
      "description": "Transfer fee is 50% of rent; minimum $500",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_3489d35f0f513e5e4b08190c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "engrain",
      "external_id": "392320",
      "name": "Washer & Dryer Rental",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_b09d9e8d72427014ba54576a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "engrain",
      "external_id": "392321",
      "name": "Lease Termination Fee",
      "description": "false",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_31f220dcbcc455c63cb4edf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "engrain",
      "external_id": "536726",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_b881193752237ad4f6537bec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "engrain",
      "external_id": "543040",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_0c023177ac703daed88b397a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "engrain",
      "external_id": "543045",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e1876758b367f92492ee6bd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "engrain",
      "external_id": "543046",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_fb035714bbc55a63e8074153",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "engrain",
      "external_id": "835092",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_b60ec2e73257afb6e9c94935",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "engrain",
      "external_id": "835093",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_dda808e6972ad51e1563ce4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "engrain",
      "external_id": "835094",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a12d2-7bce-749c-b3ee-967227bdb3a5",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-chesterfield-flats-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314"
    },
    {
      "lead_collector_id": "019c3043-4359-767d-af61-1357d0e7b9ce",
      "lead_source": "FACEBOOK_ADS",
      "name": "chesterfield-flats",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314"
    },
    {
      "lead_collector_id": "019c3043-43c9-7568-926b-6bdcc0a30659",
      "lead_source": "LANDING_PAGE",
      "name": "chesterfield-flats",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "page_item_url": "dog-friendly-apartments-richmond-va-chesterfield-flats-110",
      "search_query": "dog friendly apartments richmond va",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Richmond, VA",
      "h2_subtitle": "Discover dog-friendly apartments at Chesterfield Flats. Enjoy our pet-loving community with on-site amenities just for your furry friends.",
      "page_copy": "Welcome to Chesterfield Flats, where we offer dog-friendly apartments in Richmond, VA. Our pet-loving community is perfect for those who cherish the companionship of their furry friends. Take advantage of our on-site amenities, including a dedicated dog park where your pets can run and play freely. Our modern apartments come in one, two, or three-bedroom floor plans, each equipped with in-unit washers and dryers for added convenience.\n\nLocated in vibrant Richmond, Chesterfield Flats ensures both you and your pets enjoy an enriched lifestyle. Besides pet-focused amenities, residents benefit from a refreshing swimming pool, off-street parking, and a cutting-edge fitness center. Don't miss out—find your ideal dog-friendly apartment today by checking our availability or scheduling a tour!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
      "featured_image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015d9-9287-7060-ac1b-0fdc398717d9",
        "storage_key": "property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments in Richmond, VA",
      "seo_description": "Find your ideal dog-friendly apartment in Richmond, VA at Chesterfield Flats. Discover pet-friendly amenities and spacious floor plans today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "page_item_url": "apartments-in-unit-washer-dryer-chesterfield-county-chesterfield-flats-28",
      "search_query": "apartments with in-unit washer and dryer chesterfield county",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Chesterfield",
      "h2_subtitle": "Explore apartments featuring in-unit washers and dryers. Chesterfield Flats offers convenience and modern living in Chesterfield County.",
      "page_copy": "At Chesterfield Flats, we prioritize convenience with our spacious apartments featuring in-unit washers and dryers, located in the heart of Chesterfield County. Our thoughtfully designed one, two, and three-bedroom floor plans are perfect for residents who value modern amenities and comfort in their daily routine. \n\nExperience hassle-free living with our off-street parking, flex rent payments, and an online resident portal, making life simpler and more efficient. Take a dip in our refreshing swimming pool or stay active in our fully-equipped fitness center. Discover the lifestyle you deserve by visiting Chesterfield Flats and secure your apartment with an in-unit washer and dryer today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
      "featured_image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015d9-9287-7060-ac1b-0fdc398717d9",
        "storage_key": "property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Chesterfield",
      "seo_description": "Discover Chesterfield Flats' modern apartments featuring in-unit washers and dryers. Enjoy hassle-free living in Chesterfield County.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "page_item_url": "richmond-apartments-fitness-center-chesterfield-flats-93",
      "search_query": "richmond apartments with fitness center",
      "category": "Amenity",
      "h1_title": "Richmond Apartments with Fitness Center",
      "h2_subtitle": "Find Richmond apartments with a top-notch fitness center at Chesterfield Flats. Elevate your lifestyle with our modern amenities.",
      "page_copy": "Chesterfield Flats offers Richmond apartments with a fully-equipped fitness center, designed to cater to your active lifestyle needs. Located in Richmond, VA, our vibrant community provides a comprehensive set of amenities, making it the perfect choice for those who prioritize health and wellness. \n\nOur community boasts spacious one, two, and three-bedroom layouts that seamlessly blend comfort and style. Beyond the fitness center, residents can enjoy the refreshing swimming pool, convenient off-street parking, and resident activity programs. With a focus on modern living, Chesterfield Flats ensures you have everything needed to live a balanced, fulfilling life in Richmond.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
      "featured_image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015d9-9287-7060-ac1b-0fdc398717d9",
        "storage_key": "property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Richmond Apartments with Fitness Center",
      "seo_description": "Explore Richmond living at Chesterfield Flats, featuring a modern fitness center and spacious floor plans. Elevate your lifestyle today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "page_item_url": "apartment-with-swimming-pool-23224-chesterfield-flats-596",
      "search_query": "apartment with swimming pool 23224",
      "category": "Amenity",
      "h1_title": "Apartment with Swimming Pool in 23224",
      "h2_subtitle": "Chesterfield Flats offers apartments with a swimming pool in the 23224 area. Enjoy leisure and luxury in vibrant Richmond, VA.",
      "page_copy": "Discover unparalleled relaxation at Chesterfield Flats, featuring an apartment with a swimming pool in the 23224 area. Situated in the lively city of Richmond, VA, our community is designed to provide an idyllic and leisurely lifestyle. Our resort-style swimming pool is the perfect spot to unwind and enjoy the sun.\n\nChoose from generously designed one, two, or three-bedroom floor plans, complete with modern amenities such as in-unit washers and dryers, off-street parking, and more. Beyond the pool, residents can enjoy a variety of activities, thanks to resident events and a dedicated fitness center. Join our vibrant community and elevate your lifestyle at Chesterfield Flats.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
      "featured_image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015d9-9287-7060-ac1b-0fdc398717d9",
        "storage_key": "property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment with Swimming Pool in 23224",
      "seo_description": "Enjoy a swimming pool at Chesterfield Flats, your premier choice for relaxation and style in the 23224 area of Richmond, VA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-richmond-chesterfield-flats-35",
      "search_query": "pet friendly apartments near me richmond",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Richmond",
      "h2_subtitle": "Chesterfield Flats in Richmond offers pet-friendly apartments with a dog park. Discover a welcoming community for you and your furry friends.",
      "page_copy": "Welcome to Chesterfield Flats, where pet-friendly apartments in Richmond offer a haven for you and your furry companions. Located conveniently for local residents, our community features a delightful dog park, providing a perfect place for pets to roam and play.\n\nOur spacious one, two, and three-bedroom apartments are designed with both comfort and practicality in mind, equipped with modern features like in-unit washers and dryers and off-street parking. As a resident, you'll also enjoy access to a refreshing swimming pool and a fully-equipped fitness center. At Chesterfield Flats, you'll find a warm, welcoming atmosphere tailored to make you and your pets feel at home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
      "featured_image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015d9-9287-7060-ac1b-0fdc398717d9",
        "storage_key": "property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Richmond",
      "seo_description": "Discover pet-friendly apartments in Richmond at Chesterfield Flats, featuring a dog park and modern amenities for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-richmond-va-chesterfield-flats-918",
      "search_query": "one bedroom apartments richmond va",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Richmond, VA",
      "h2_subtitle": "Explore comfortable one-bedroom apartments in Richmond, VA at Chesterfield Flats. Our community offers modern living with excellent amenities.",
      "page_copy": "Chesterfield Flats presents premier one-bedroom apartments in Richmond, VA, perfect for those seeking a cozy yet modern living space. Our community combines superb comfort with top-tier amenities, making it an ideal choice for individuals and couples.\n\nEach one-bedroom apartment comes equipped with essential amenities like in-unit washers and dryers, ensuring convenience and ease. Beyond the beautifully designed interiors, residents enjoy an array of features including a sparkling swimming pool, a fitness center, and off-street parking. Located in vibrant Richmond, Chesterfield Flats offers an unmatched residential experience that feels like home from day one.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
      "featured_image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015d9-9287-7060-ac1b-0fdc398717d9",
        "storage_key": "property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Richmond, VA",
      "seo_description": "Find your one-bedroom retreat at Chesterfield Flats in Richmond, VA. Enjoy modern amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-chesterfield-county-chesterfield-flats-606",
      "search_query": "two bedroom apartments chesterfield county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Chesterfield County",
      "h2_subtitle": "Discover spacious two-bedroom apartments in Chesterfield County at Chesterfield Flats, offering modern amenities and a welcoming community.",
      "page_copy": "Welcome to Chesterfield Flats, where our two-bedroom apartments in Chesterfield County provide the ideal blend of comfort and style. Perfectly suited for families or roommates, these spacious living options ensure ample room for all your needs.\n\nOur community boasts a range of amenities including in-unit washers and dryers, off-street parking, and a luxurious swimming pool. Whether you want to relax by the pool or enjoy a workout in the fully-equipped fitness center, Chesterfield Flats offers all you need for a convenient and enjoyable lifestyle. Situated in the heart of Richmond, VA, experience quality living at Chesterfield Flats today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
      "featured_image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015d9-9287-7060-ac1b-0fdc398717d9",
        "storage_key": "property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Chesterfield County",
      "seo_description": "Explore two-bedroom apartments at Chesterfield Flats in Chesterfield County. Enjoy modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-23224-chesterfield-flats-990",
      "search_query": "three bedroom apartments 23224",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in 23224",
      "h2_subtitle": "Explore spacious three-bedroom apartments in the 23224 area at Chesterfield Flats. Ideal for families looking for comfort and convenience.",
      "page_copy": "Discover the perfect home for your family with the three-bedroom apartments available at Chesterfield Flats, located in the vibrant 23224 ZIP code of Richmond. These generously-sized units offer ample space and modern comforts, making them an excellent choice for growing families.\n\nResidents of Chesterfield Flats enjoy a host of amenities, including in-unit washers and dryers, a pristine swimming pool, and a state-of-the-art fitness center. Our pet-friendly community is designed to cater to both relaxation and active lifestyles. Experience the synergy of an ideal location and superb living at Chesterfield Flats, ensuring an extraordinary residential experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
      "featured_image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015d9-9287-7060-ac1b-0fdc398717d9",
        "storage_key": "property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in 23224",
      "seo_description": "Find your spacious three-bedroom apartment in the 23224 area at Chesterfield Flats. Enjoy modern amenities and family-friendly living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "page_item_url": "apartments-near-ja-chalkley-elementary-richmond-chesterfield-flats-462",
      "search_query": "apartments near j.a. chalkley elementary school richmond",
      "category": "School",
      "h1_title": "Apartments Near J.A. Chalkley Elementary",
      "h2_subtitle": "Discover convenient apartments near J.A. Chalkley Elementary School in Richmond at Chesterfield Flats, offering modern living for families.",
      "page_copy": "Chesterfield Flats is the perfect choice for families seeking apartments near J.A. Chalkley Elementary School in Richmond. Offering a variety of spacious floor plans, it's an ideal community for families who value both education and modern living.\n\nOur residents enjoy a suite of amenities, such as in-unit washers and dryers, a community swimming pool, and a fitness center. Located in a family-friendly area, our community provides the comfort and convenience that cater to both parents and children. Secure a home at Chesterfield Flats, where quality education and vibrant living combine seamlessly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
      "featured_image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015d9-9287-7060-ac1b-0fdc398717d9",
        "storage_key": "property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near J.A. Chalkley Elementary School",
      "seo_description": "Find family-friendly apartments near J.A. Chalkley Elementary School in Richmond at Chesterfield Flats. Enjoy modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "page_item_url": "chesterfield-county-apartments-near-providence-middle-school-734",
      "search_query": "chesterfield county apartments close to providence middle school",
      "category": "School",
      "h1_title": "Chesterfield County Apartments Near Providence MS",
      "h2_subtitle": "Find Chesterfield County apartments close to Providence Middle School. Enjoy ideal living at Chesterfield Flats with top amenities for families.",
      "page_copy": "Welcome to Chesterfield Flats, perfectly situated for families seeking Chesterfield County apartments close to Providence Middle School. Our community provides an excellent location with an array of convenient and modern amenities, making it a favored choice among families.\n\nResidents have access to features such as in-unit washers and dryers, a refreshing swimming pool, and a pet-friendly atmosphere with a dedicated dog park. Whether you're prioritizing proximity to quality education or seeking family-friendly amenities, Chesterfield Flats offers both, ensuring a superior living experience in Richmond, VA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
      "featured_image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015d9-9287-7060-ac1b-0fdc398717d9",
        "storage_key": "property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Chesterfield County Apts Near Providence Middle School",
      "seo_description": "Explore Chesterfield County apartments near Providence Middle School at Chesterfield Flats. Offering family-friendly amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "page_item_url": "apartments-by-meadowbrook-high-school-va-chesterfield-flats-413",
      "search_query": "apartments by meadowbrook high school va",
      "category": "School",
      "h1_title": "Apartments by Meadowbrook High School, VA",
      "h2_subtitle": "Explore apartments by Meadowbrook High School, VA, at Chesterfield Flats. Perfect for families seeking quality education and modern living.",
      "page_copy": "Situated near Meadowbrook High School in VA, Chesterfield Flats offers the perfect home for families looking to balance exceptional educational opportunities with modern amenities. Our community offers spacious one, two, and three-bedroom layouts, ensuring comfort and flexibility for any family size.\n\nResidents enjoy conveniences such as in-unit washers and dryers and exclusive access to community features like a refreshing pool and a fitness center. Our family-focused environment and strategic location make living in Chesterfield Flats a harmonious blend of lifestyle and accessibility, ideal for families prioritizing education and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
      "featured_image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015d9-9287-7060-ac1b-0fdc398717d9",
        "storage_key": "property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Meadowbrook High School, VA",
      "seo_description": "Discover family-friendly apartments by Meadowbrook High School, VA, at Chesterfield Flats. Enjoy modern amenities close to quality education.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "page_item_url": "richmond-apartments-near-swansboro-elementary-school-chesterfield-flats-903",
      "search_query": "richmond apartments near swansboro elementary school",
      "category": "School",
      "h1_title": "Richmond Apartments Near Swansboro Elementary",
      "h2_subtitle": "Discover Richmond apartments near Swansboro Elementary School. Chesterfield Flats offers family-friendly living with top-notch amenities.",
      "page_copy": "Chesterfield Flats is an ideal choice for families seeking Richmond apartments near Swansboro Elementary School. Our community not only offers proximity to quality education but also provides an inviting living environment with a host of modern amenities.\n\nEnjoy spacious living with a selection of one, two, or three-bedroom apartments. Residents benefit from a refreshing swimming pool, pet-friendly spaces, and a fully-equipped fitness center. The vibrant atmosphere and family-centric environment make Chesterfield Flats a top choice for those who want both convenience and comfort in Richmond.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
      "featured_image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015d9-9287-7060-ac1b-0fdc398717d9",
        "storage_key": "property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Richmond Apartments Close to Swansboro Elementary",
      "seo_description": "Find Richmond apartments near Swansboro Elementary School at Chesterfield Flats. Enjoy a family-friendly community with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "page_item_url": "apartments-near-oak-grove-bellemeade-elementary-23224-674",
      "search_query": "apartments near oak grove-bellemeade elementary school 23224",
      "category": "School",
      "h1_title": "Apartments Near Oak Grove-Bellemeade Elem 23224",
      "h2_subtitle": "Explore apartments near Oak Grove-Bellemeade Elementary, located in the 23224 area. Chesterfield Flats offers an ideal living environment for families.",
      "page_copy": "Located in the vibrant 23224 area, Chesterfield Flats offers families easy access to Oak Grove-Bellemeade Elementary School. Our community is perfect for those seeking comfort and convenience, with spacious floor plans including one, two, and three-bedroom apartments.\n\nChesterfield Flats features a range of amenities designed for modern living: in-unit washers and dryers, a welcoming swimming pool, and secure off-street parking. Ideal for families prioritizing education and lifestyle, our community provides everything you need for a fulfilling living experience in Richmond.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
      "featured_image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015d9-9287-7060-ac1b-0fdc398717d9",
        "storage_key": "property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Oak Grove-Bellemeade Elementary 23224",
      "seo_description": "Find apartments near Oak Grove-Bellemeade Elementary in the 23224 area at Chesterfield Flats. Family-friendly with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "page_item_url": "chesterfield-county-apartments-by-cardinal-elementary-chesterfield-flats-590",
      "search_query": "chesterfield county apartments by cardinal elementary school",
      "category": "School",
      "h1_title": "Chesterfield Apartments by Cardinal Elementary",
      "h2_subtitle": "Live near Cardinal Elementary School in Chesterfield County. Chesterfield Flats offers apartments designed for family-friendly living.",
      "page_copy": "Chesterfield Flats provides the perfect home for families searching for Chesterfield County apartments by Cardinal Elementary School. Nestled in a community focused on comfort and education, our property offers a variety of spacious one, two, and three-bedroom options tailored to your family's needs.\n\nOur amenities include a refreshing pool, pet-friendly dog park, and a fitness center, making it easy for families to stay active and connected. With its convenient location near top schools, Chesterfield Flats combines accessibility with a family-oriented atmosphere, perfect for families prioritizing education.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
      "featured_image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015d9-9287-7060-ac1b-0fdc398717d9",
        "storage_key": "property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Chesterfield Apts Near Cardinal Elementary School",
      "seo_description": "Discover Chesterfield County apartments by Cardinal Elementary School at Chesterfield Flats. Enjoy family-friendly living with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "page_item_url": "apartments-close-to-vcu-richmond-chesterfield-flats-846",
      "search_query": "apartments close to virginia commonwealth university richmond",
      "category": "School",
      "h1_title": "Apartments Close to VCU, Richmond",
      "h2_subtitle": "Find convenient apartments close to Virginia Commonwealth University in Richmond. Chesterfield Flats is perfect for students and professionals alike.",
      "page_copy": "Chesterfield Flats offers an excellent option for those seeking apartments close to Virginia Commonwealth University in Richmond. Our community balances modern living with close proximity to campus, ensuring that students and professionals have everything they need.\n\nLocated just a short drive from VCU, Chesterfield Flats features spacious one, two, and three-bedroom apartments. Residents enjoy a wide range of amenities, including a swimming pool, fitness center, and exclusive resident activities. With its convenient location and exceptional features, Chesterfield Flats is the ideal choice for easy access to campus life and city amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
      "featured_image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015d9-9287-7060-ac1b-0fdc398717d9",
        "storage_key": "property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near VCU Richmond",
      "seo_description": "Explore Chesterfield Flats: Apartments close to Virginia Commonwealth University, Richmond. Ideal for students and professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "page_item_url": "apartments-near-central-va-health-care-system-richmond-135",
      "search_query": "apartments near Central Virginia VA Health Care System Richmond",
      "category": "Hospital",
      "h1_title": "Apartments Near Central VA Health Care Richmond",
      "h2_subtitle": "Find ideal living arrangements near Central Virginia VA Health Care System Richmond. Chesterfield Flats offers comfort and convenience.",
      "page_copy": "Chesterfield Flats is your go-to choice for apartments near the Central Virginia VA Health Care System in Richmond. Our community stands out with spacious one, two, and three-bedroom apartments, creating an ideal living space for healthcare professionals, patients, and their families seeking proximity to vital services.\n\nWith amenities such as a refreshing swimming pool, a fully-equipped fitness center, and a welcoming pet-friendly dog park, Chesterfield Flats not only provides convenience but also quality living. Located just a short drive from the healthcare system, our community offers residents both ease and accessibility, making everyday commutes simple and stress-free.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
      "featured_image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015d9-9287-7060-ac1b-0fdc398717d9",
        "storage_key": "property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Central VA Health Care, Richmond",
      "seo_description": "Chesterfield Flats: Comfortable apartments near Central Virginia VA Health Care System Richmond. Perfect for healthcare professionals and families.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "page_item_url": "apartments-close-to-chippenham-hospital-chesterfield-county-282",
      "search_query": "apartments close to Chippenham Hospital Chesterfield County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Chippenham Hospital",
      "h2_subtitle": "Explore spacious apartments close to Chippenham Hospital in Chesterfield County. Chesterfield Flats offers comfort and convenience for medical staff and patients.",
      "page_copy": "Located near Chippenham Hospital in Chesterfield County, Chesterfield Flats provides the perfect solution for those searching for convenient housing. Our community features spacious one, two, and three-bedroom apartments, ideal for medical professionals, patients, and their families seeking easy access to healthcare.\n\nResidents at Chesterfield Flats enjoy a range of top-notch amenities, including a washer and dryer in each unit, a pet-friendly dog park, and a state-of-the-art fitness center. Positioned just a short distance from the hospital, our community ensures a blend of comfortable living and practical convenience, making daily routines effortless and stress-free.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
      "featured_image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015d9-9287-7060-ac1b-0fdc398717d9",
        "storage_key": "property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Chippenham Hospital Chesterfield",
      "seo_description": "Chesterfield Flats: Ideal apartments close to Chippenham Hospital, Chesterfield County. Perfect for medical staff and families.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "page_item_url": "chesterfield-flats-near-robious-landing-park-876",
      "search_query": "chesterfield flats near robious landing park",
      "category": "Park",
      "h1_title": "Chesterfield Flats Near Robious Landing",
      "h2_subtitle": "Discover Chesterfield Flats, ideally located near Robious Landing Park. Perfect for nature lovers seeking modern comfort and convenience.",
      "page_copy": "Nestled near the serene Robious Landing Park, Chesterfield Flats offers a unique combination of modern living and natural beauty. Our community is perfect for those who love the outdoors, providing easy access to the park's scenic trails and riverside views while enjoying the amenities of contemporary apartment living.\n\nChesterfield Flats features spacious floor plans with one, two, and three-bedroom options, along with amenities like a refreshing swimming pool and a fully-equipped fitness center. Whether you're spending the day exploring Robious Landing Park or relaxing at home, Chesterfield Flats ensures you enjoy the best of both worlds. Make Chesterfield Flats your new home and embrace a lifestyle that offers both convenience and nature's tranquility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
      "featured_image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015d9-9287-7060-ac1b-0fdc398717d9",
        "storage_key": "property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Chesterfield Flats Near Robious Park",
      "seo_description": "Chesterfield Flats: Apartments near Robious Landing Park, ideal for outdoor enthusiasts seeking modern living close to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "page_item_url": "richmond-apartments-close-to-huguenot-park-551",
      "search_query": "richmond apartments close to huguenot park",
      "category": "Park",
      "h1_title": "Richmond Apartments Near Huguenot Park",
      "h2_subtitle": "Discover Richmond apartments conveniently close to Huguenot Park. Chesterfield Flats offers spacious living with top-notch amenities.",
      "page_copy": "Experience the blend of nature and urban living at Chesterfield Flats, located near the peaceful Huguenot Park in Richmond. Our community is perfect for those who appreciate the convenience of city living with easy access to wide open green spaces. Choose from our spacious one, two, or three-bedroom apartments, all designed to provide maximum comfort.\n\nChesterfield Flats offers a plethora of amenities, including a refreshing swimming pool and a pet-friendly dog park, making it an ideal home for families and pet owners. The community's proximity to Huguenot Park ensures you have endless opportunities for outdoor activities, whether it's a leisurely walk or a family picnic. Make Chesterfield Flats your next home, where every day brings new adventures right outside your door.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
      "featured_image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015d9-9287-7060-ac1b-0fdc398717d9",
        "storage_key": "property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Richmond Apts Near Huguenot Park",
      "seo_description": "Chesterfield Flats: Richmond apartments close to Huguenot Park, offering spacious living and modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166314",
      "source": "custom",
      "page_item_url": "apartments-near-dorey-park-recreation-center-va-220",
      "search_query": "apartments near dorey park and recreation center va",
      "category": "Park",
      "h1_title": "Apartments Near Dorey Park & Recreation",
      "h2_subtitle": "Live near Dorey Park and Recreation Center, VA at Chesterfield Flats. Experience modern amenities and enjoy easy park access for a balanced lifestyle.",
      "page_copy": "Chesterfield Flats is the ideal choice for those looking for apartments near Dorey Park and Recreation Center, VA. Our community offers a seamless integration of comfort and convenience, perfect for individuals and families who enjoy an active lifestyle. With beautiful Dorey Park just a short drive away, residents can take advantage of miles of trails, sports facilities, and open green spaces.\n\nChoose from our stylish one, two, or three-bedroom apartments, equipped with all the modern amenities you need, including in-unit washers and dryers and an online resident portal for easy management. This vibrant community also boasts a fitness center and a swimming pool, making it perfect for those who appreciate recreation and relaxation in equal measure. Make your home at Chesterfield Flats, where adventure and relaxation are always within reach.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
      "featured_image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a015d9-9287-7060-ac1b-0fdc398717d9",
        "storage_key": "property/6767906449166314/01a015d9-9287-7060-ac1b-0fdc398717d9.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Dorey Park and Recreation Center VA",
      "seo_description": "Find your home at Chesterfield Flats, with apartments near Dorey Park and Recreation Center, offering great amenities and park access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5052"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976239197"
    },
    {
      "ID": "custom_fee_guide",
      "type": "BOOLEAN",
      "value": "true"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4993354"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TGSZD66R"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://chesterfieldflats.fatwin.com/api/websites/resources/1?x=M3pmL3VFVFlKd3N1UHpMUjlkdWkvSURxdG1oMHdyREYxOXQ5eDF2NEdjRTVVN3dLN2pBV2RJN29Bb1NzSTNENjlCT2wySDhhSXVGRjdDdWhDblEyS2c9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "53465975365"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/m9pz4k64vk1"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "9549bb90-43e6-11ef-860a-5fefa801d3fa"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549bb90-43e6-11ef-860a-5fefa801d3fa/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549bb90-43e6-11ef-860a-5fefa801d3fa/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImJyazhzcUQ5dmlzL25PeXZrREtqelE9PSIsInZhbHVlIjoiWVJuL0k5WitlNzlueXdvWUFHREJ0QT09IiwibWFjIjoiYWU1ZGQ1ODg0YzA4ZDJjMjY4NzZhZDkyZWJhOTZiMmZmNmU5ODQ1NWE0ZmYyMjk5MTE1YTBmY2Q0OWRkM2RlOSJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5052",
  "custom_repli_id": "9976239197",
  "custom_fee_guide": "true",
  "custom_realpage_id": "4993354",
  "custom_google_gtm_id": "GTM-TGSZD66R",
  "custom_perq_script_url": "https://chesterfieldflats.fatwin.com/api/websites/resources/1?x=M3pmL3VFVFlKd3N1UHpMUjlkdWkvSURxdG1oMHdyREYxOXQ5eDF2NEdjRTVVN3dLN2pBV2RJN29Bb1NzSTNENjlCT2wySDhhSXVGRjdDdWhDblEyS2c9PQ2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "53465975365",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/m9pz4k64vk1",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "9549bb90-43e6-11ef-860a-5fefa801d3fa",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549bb90-43e6-11ef-860a-5fefa801d3fa/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549bb90-43e6-11ef-860a-5fefa801d3fa/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImJyazhzcUQ5dmlzL25PeXZrREtqelE9PSIsInZhbHVlIjoiWVJuL0k5WitlNzlueXdvWUFHREJ0QT09IiwibWFjIjoiYWU1ZGQ1ODg0YzA4ZDJjMjY4NzZhZDkyZWJhOTZiMmZmNmU5ODQ1NWE0ZmYyMjk5MTE1YTBmY2Q0OWRkM2RlOSJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "d5ccd222-9331-4347-8476-a8592ccae56b",
  "custom_audioeye_site_hash": "14f37a6fcabad2ebada2ab64cc5a7f31"
};

export const generatedAt = '2026-10-22T20:07:42.198Z';
